<template>
  <div class="lifeAlbum_page">
    <div class="lifeAlbum_page_modal" v-if="pageModal">
      <div v-show="!pageModalText">
        <img src="@/assets/images/space/photo_loading.png" />
      </div>
      <span v-show="pageModalText">{{ pageModalText }}</span>
    </div>
    <div class="lifeAlbum_step_body">
      <div
        class="lifeAlbum_step_button lifeAlbum_step_button1"
        :style="this.stepActive >= 0 ? 'cursor: pointer;' : ''"
        @click="lifeAlbumStepClick(1, true)"
      ></div>
      <div
        class="lifeAlbum_step_button lifeAlbum_step_button2"
        :style="this.stepActive >= 1 ? 'cursor: pointer;' : ''"
        @click="lifeAlbumStepClick(2, true)"
      ></div>
      <div
        class="lifeAlbum_step_button lifeAlbum_step_button3"
        :style="this.stepActive >= 2 ? 'cursor: pointer;' : ''"
        @click="lifeAlbumStepClick(3, true)"
      ></div>
      <el-steps
        :space="300"
        :active="stepActive"
        finish-status="success"
        align-center
      >
        <el-step title="上传和编辑照片"></el-step>
        <el-step title="人生相册模版选择"></el-step>
        <el-step title="视频修改和下载"></el-step>
      </el-steps>
    </div>

    <div
      v-show="!aiPicComposite"
      :class="'lifeAlbum_pic_body' + (stepActive == 2 ? ' noborder' : '')"
    >
      <template v-if="stepActive == 0">
        <div class="lifeAlbum_pic_bar">
          <div class="lifeAlbum_pic_bar_title" v-show="choicePicType == 0">
            照片资料库：<!-- {{ picList.length }}/{{uploadLimitMax}} -->
            <!-- <template v-if="!existPhotoAi"
              >照片资料库：</template
            >
            <a
              v-if="existPhotoAi"
              href="javascript:void(0);"
              @click="replacePhotoAiUrlAll()"
              >全部替换</a
            > -->
          </div>
          <div class="lifeAlbum_pic_bar_title" v-show="choicePicType > 0">
            已选照片：{{ choicePicCount }}/{{ picList.length }}
            <a href="javascript:void(0);" @click="choicePhotoAll()">全选</a>
          </div>
          <div class="lifeAlbum_pic_bar_buttons">
            <!-- <el-button
              type="primary"
              v-show="picList.length > 0 && choicePicType == 0"
              @click="choicePhoto(2)"
              >AI照片合成</el-button
            > -->
            <!-- <el-button
              type="primary"
              v-show="picList.length > 0 && choicePicType == 0"
              @click="choicePhoto(3)"
              >照片优化</el-button
            > -->
            <el-button
              type="primary"
              v-show="
                picList.length > 0 && choicePicType == 0 && showPhotoAiAllButton
              "
              @click="editPhotoAiUrlAll()"
              >照片一键优化</el-button
            >
            <!-- <el-button
              type="primary"
              v-show="picList.length > 0 && choicePicType == 0"
              @click="choicePhoto(4)"
              >去除折痕</el-button
            > -->
            <el-button
              v-show="choicePicType == 0 && picList.length >= uploadLimitMax"
              @click="uploadLimit()"
              >上传</el-button
            >
            <el-button
              v-show="choicePicType == 0 && picList.length < uploadLimitMax"
              @click="triggerUploadButton()"
              >上传</el-button
            >
            <el-upload
              v-show="false"
              action=""
              :file-list="picList"
              :show-file-list="false"
              :before-upload="uploadBefore"
              :on-progress="uploadProcess"
              :on-success="uploadSuccess"
              :on-error="uploadError"
              :on-exceed="uploadExceed"
              :http-request="uploadRequest"
              :limit="uploadLimitMax"
              multiple
              ref="upLoadButton"
              class="upLoad_button"
              :on-change="uploadChange"
            >
              <el-button>上传</el-button>
            </el-upload>
            <el-upload
              v-show="false"
              action=""
              :show-file-list="false"
              :before-upload="uploadBefore"
              :on-progress="uploadProcess"
              :on-success="uploadSuccess"
              :on-error="uploadError"
              :on-exceed="uploadExceed"
              :http-request="uploadRequest"
              ref="replaceButton"
              class="upLoad_button"
              :on-change="uploadChange"
            >
              <el-button>替换</el-button>
            </el-upload>
            <el-button
              v-show="picList.length > 0 && choicePicType == 0"
              @click="choicePhoto(1)"
              >删除</el-button
            >
            <el-button v-show="choicePicType > 0" @click="choicePhotoCancel()"
              >取消</el-button
            >
            <el-button
              type="primary"
              v-show="choicePicType > 0"
              @click="choicePhotoConfirm()"
              >确定</el-button
            >
          </div>
        </div>
        <div class="lifeAlbum_pic_content">
          <!-- 暂无照片 -->
          <div class="lifeAlbum_pic_empty" v-show="picList.length == 0">
            <div
              class="lifeAlbum_pic_empty_border"
              @click="triggerUploadButton()"
            >
              <img src="@/assets/images/space/upload.png" />
              <span>点击上传照片（2-{{ uploadLimitMax }}张）</span>
            </div>
          </div>
          <!-- 显示照片 -->
          <div class="lifeAlbum_pic_list" v-show="picList.length > 0">
            <draggable
              class="lifeAlbum_pic_list_draggable"
              v-model="picList"
              :options="{
                sort: true,
                disabled: !true,
              }"
              group="photos"
              @start="draggableStart"
              @end="draggableEnd"
              :move="(event) => draggableMove(event)"
            >
              <div
                class="lifeAlbum_pic_list_item"
                v-for="(item, i) in picList"
                :key="item.id"
              >
                <div
                  class="lifeAlbum_pic_list_item_content"
                  :style="
                    choicePicType == 0 &&
                    item.progress != 0 &&
                    item.aiProgress != 0
                      ? ''
                      : 'cursor: pointer;'
                  "
                  @click="clickChoicePhoto(i)"
                  @dblclick="replacePhotoAiUrlShow(item, i)"
                >
                  <img
                    v-if="item.photoUrl"
                    :class="
                      item.progress > 0 && item.progress < 100
                        ? 'lifeAlbum_pic_list_item_img_process'
                        : ''
                    "
                    :src="
                      item.photoUrl +
                      (item.photoUrl.indexOf('https') == 0
                        ? '?x-oss-process=image/resize,m_fill,h_116,w_116'
                        : '')
                    "
                  />
                  <!-- AI合成图标 -->
                  <img
                    class="lifeAlbum_pic_list_item_type_ai"
                    v-if="item.type == 1"
                    src="@/assets/images/space/ai_icon.png"
                    alt=""
                  />
                  <!-- 遗像图标 -->
                  <img
                    class="lifeAlbum_pic_list_item_type_ai"
                    v-if="i == 0"
                    src="@/assets/images/space/dead_icon.png"
                    alt=""
                  />
                  <!-- 上传状态图标 -->
                  <div
                    class="lifeAlbum_pic_list_item_process"
                    v-if="item.progress >= 0 && item.progress <= 100"
                  >
                    <img
                      class="lifeAlbum_pic_list_item_process_success"
                      v-if="item.progress == 100"
                      src="@/assets/images/space/iv_update_success.png"
                      alt=""
                    />
                    <img
                      class="lifeAlbum_pic_list_item_process_failed"
                      src="@/assets/images/space/iv_update_failed.png"
                      v-if="choicePicType == 0 && item.progress == 0"
                      alt=""
                      @click="reuploadRequest(item, i)"
                    />
                    <el-progress
                      v-if="item.progress > 0 && item.progress < 100"
                      :percentage="item.progress"
                      :stroke-width="10"
                      color="#2C90FF"
                      class="lifeAlbum_pic_list_item_process_bar"
                      :show-text="false"
                    ></el-progress>
                  </div>
                  <!-- 选中状态图标 -->
                  <img
                    class="lifeAlbum_pic_list_item_choice"
                    v-if="choicePicType > 0 && item.checked"
                    src="@/assets/images/space/iv_choice_photo.png"
                    alt=""
                  />
                  <img
                    class="lifeAlbum_pic_list_item_choice"
                    v-if="choicePicType > 0 && !item.checked"
                    src="@/assets/images/space/iv_choice_can.png"
                    alt=""
                  />
                  <!-- 照片优化状态图标 -->
                  <!-- <div
                    class="lifeAlbum_pic_list_item_choice_ai"
                    v-if="
                      choicePicType == 0 &&
                      item.aiUrl != undefined &&
                      item.aiUrl != ''
                    "
                    @dblclick="replacePhotoAiUrlShow(item, i)"
                  >
                    <img
                      class="lifeAlbum_pic_list_item_choice_red_dot"
                      src="@/assets/images/space/red_dot.svg"
                      alt=""
                    />
                  </div> -->
                  <!-- 照片优化loading -->
                  <div
                    class="lifeAlbum_pic_list_item_process"
                    v-if="item.aiProgress >= 0 && item.aiProgress < 100"
                  >
                    <img
                      class="lifeAlbum_pic_list_item_process_loading"
                      v-if="item.aiProgress > 0 && item.aiProgress < 100"
                      src="@/assets/images/OauthApply/loading.gif"
                      alt=""
                    />
                    <img
                      class="lifeAlbum_pic_list_item_process_failed"
                      src="@/assets/images/space/iv_update_ai.png"
                      v-if="choicePicType == 0 && item.aiProgress == 0"
                      alt=""
                      @click="editPhotoAiUrl(item, i)"
                    />
                  </div>
                </div>
                <!-- 图片序号 -->
                <span class="lifeAlbum_pic_list_item_index">{{ i + 1 }}</span>
                <!-- 图片更多选项 -->
                <img
                  v-if="choicePicType == 0"
                  class="lifeAlbum_pic_list_item_three_dot"
                  src="@/assets/images/space/iv_three_dot.png"
                  @click.stop="clickPhotoOptions(i)"
                />
                <div
                  class="lifeAlbum_pic_list_item_options"
                  v-if="photoOptionsIndex == i"
                >
                  <div
                    class="lifeAlbum_pic_list_item_options_float_all"
                    @click="replacePhotoByIds(i)"
                  >
                    <img
                      class="lifeAlbum_pic_list_item_options_float_icon"
                      src="@/assets/images/space/iv_photo_replace.png"
                      alt=""
                    />
                    <div class="lifeAlbum_pic_list_item_options_float_black">
                      替换
                    </div>
                  </div>
                  <div class="lifeAlbum_pic_list_item_options_float_line"></div>
                  <div
                    class="lifeAlbum_pic_list_item_options_float_all"
                    @click="delPhotoByIds(item, i)"
                  >
                    <img
                      class="lifeAlbum_pic_list_item_options_float_icon"
                      src="@/assets/images/space/iv_photo_delete.png"
                      alt=""
                    />
                    <div class="lifeAlbum_pic_list_item_options_float_red">
                      删除
                    </div>
                  </div>
                </div>
              </div>
            </draggable>
          </div>
        </div>
        <div class="lifeAlbum_pic_button" v-show="picList.length > 0">
          <el-button
            type="primary"
            v-show="choicePicType == 0"
            @click="addLifeAlbumTemplate()"
            >确认照片并选择模板</el-button
          >
        </div>
      </template>
      <template v-if="stepActive == 1">
        <div class="lifeAlbum_pic_bar">
          <div class="lifeAlbum_pic_bar_title">模版选择：</div>
        </div>
        <div class="lifeAlbum_template_content">
          <div class="lifeAlbum_template_flex">
            <el-form
              :model="dataInfo"
              ref="dataInfoRef"
              label-width="110px"
              class="lifeAlbum_template_form"
            >
              <el-form-item
                prop="bgCode"
                label="背景："
                :rules="{
                  required: true,
                  message: '请选择背景',
                }"
              >
                <el-select v-model="dataInfo.bgCode" placeholder="请选择">
                  <el-option
                    v-for="(item, index) in templateBgList"
                    :label="item.content"
                    :value="item.code"
                    :key="index"
                  ></el-option>
                </el-select>
                <span @click="viewLifeAlbumTemplateShow(1)">查看背景库</span>
              </el-form-item>
              <el-form-item
                prop="musicCode"
                label="音乐："
                :rules="{
                  required: true,
                  message: '请选择音乐',
                }"
              >
                <el-select v-model="dataInfo.musicCode" placeholder="请选择">
                  <el-option
                    v-for="(item, index) in templateMusicList"
                    :label="item.content"
                    :value="item.code"
                    :key="index"
                  ></el-option>
                </el-select>
                <span @click="viewLifeAlbumTemplateShow(2)">查看音乐库</span>
              </el-form-item>
              <el-form-item
                prop="beginEndState"
                label="开头和结尾："
                :rules="{
                  required: true,
                  message: '请选择开头和结尾',
                }"
              >
                <el-select
                  v-model="dataInfo.beginEndState"
                  @change="beginEndStateChange"
                >
                  <el-option label="有" :value="1"></el-option>
                  <el-option label="无" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <template v-if="templateSubtitleShow">
                <el-form-item
                  prop="subtitle1Code"
                  label="人生角色："
                  :rules="{
                    required: templateSubtitleRequired,
                    message: '请选择人生角色',
                  }"
                >
                  <el-select
                    v-model="dataInfo.subtitle1Code"
                    :disabled="templateSubtitleDisabled"
                    placeholder="请选择"
                    @change="templateSubtitle1Change"
                  >
                    <el-option
                      v-for="(item, index) in templateSubtitle1List"
                      :label="item.content"
                      :value="item.code"
                      :key="index"
                    ></el-option>
                  </el-select>
                  <span
                    :class="
                      templateSubtitleDisabled
                        ? 'template_subtitle_disabled'
                        : ''
                    "
                    @click="viewLifeAlbumTemplateShow(3)"
                    >查看人生角色库</span
                  >
                </el-form-item>
                <el-form-item
                  prop="subtitle2Code"
                  label="人才类型："
                  :rules="{
                    required: templateSubtitleRequired,
                    message: '请选择人才类型',
                  }"
                >
                  <el-select
                    v-model="dataInfo.subtitle2Code"
                    :disabled="templateSubtitleDisabled"
                    placeholder="请选择"
                    @change="templateSubtitleChange"
                  >
                    <el-option
                      v-for="(item, index) in templateSubtitle2List"
                      :label="item.content"
                      :value="item.code"
                      :key="index"
                    ></el-option>
                  </el-select>
                  <span
                    :class="
                      templateSubtitleDisabled
                        ? 'template_subtitle_disabled'
                        : ''
                    "
                    @click="viewLifeAlbumTemplateShow(4)"
                    >查看人才类型库</span
                  >
                </el-form-item>
                <el-form-item
                  prop="subtitle3Code"
                  label="天命："
                  :rules="{
                    required: templateSubtitleRequired,
                    message: '请选择天命',
                  }"
                >
                  <el-select
                    v-model="dataInfo.subtitle3Code"
                    :disabled="templateSubtitleDisabled"
                    placeholder="请选择"
                    @change="templateSubtitleChange"
                  >
                    <el-option
                      v-for="(item, index) in templateSubtitle3List"
                      :label="item.content"
                      :value="item.code"
                      :key="index"
                    ></el-option>
                  </el-select>
                  <span
                    :class="
                      templateSubtitleDisabled
                        ? 'template_subtitle_disabled'
                        : ''
                    "
                    @click="viewLifeAlbumTemplateShow(5)"
                    >查看天命库</span
                  >
                </el-form-item>
              </template>
            </el-form>
          </div>
        </div>
        <div class="lifeAlbum_pic_button">
          <el-button type="primary" @click="createLifeAlbum()"
            >开始制作相册</el-button
          >
        </div>
      </template>
      <template v-if="stepActive == 2">
        <div class="lifeAlbum_video_flex">
          <div class="lifeAlbum_video_process" v-show="!videoShow">
            <el-progress
              :text-inside="true"
              :percentage="videoProcess"
              :stroke-width="25"
              color="#2C90FF"
              class="lifeAlbum_video_process_bar"
            ></el-progress>
            <span
              v-show="!downloadVideoUrl"
              class="lifeAlbum_video_process_span"
              >{{ videoProcessText }}</span
            >
            <span v-show="downloadVideoUrl" class="lifeAlbum_video_process_span"
              >下载处理完成！</span
            >
            <!-- <a
              v-show="downloadVideoUrl"
              :href="downloadVideoUrl"
              @click="videoShow = true"
              >下载处理完成，请点击下载！</a
            > -->
            <a
              v-show="videoProcessButton > 0"
              href="javascript:void(0);"
              @click="clickVideoProcessButton()"
              >关闭</a
            >
          </div>
          <video
            class="lifeAlbum_video_info"
            v-if="videoShow"
            controls
            controlsList="nodownload"
            preload="auto"
          >
            <source
              :src="
                dataInfo.videoUrl && dataInfo.videoUrl.indexOf('https') == 0
                  ? dataInfo.videoUrl + '?' + new Date().getTime()
                  : dataInfo.videoUrl
              "
              type="video/mp4"
            />
            <track
              kind="subtitles"
              srclang="zh"
              label="中文"
              :src="
                dataInfo.beginEndState == 1 &&
                dataInfo.videoSubtitleUrl &&
                dataInfo.videoSubtitleUrl.indexOf('https') == 0
                  ? '/api/common/getUrlDataSourceToGet?url=' +
                    encodeURIComponent(
                      dataInfo.videoSubtitleUrl + '?' + new Date().getTime()
                    )
                  : dataInfo.videoSubtitleUrl
              "
              default
            />
          </video>
        </div>
        <div class="lifeAlbum_video_button">
          <div v-show="videoShow">
            <el-button @click="lifeAlbumStepClick(4)">修改视频照片</el-button>
            <el-button @click="cleanLifeAlbum(3)">重选模板</el-button>
            <el-button
              type="primary"
              class="lifeAlbum_video_download_button"
              @click="downloadLifeAlbum(2)"
              >&nbsp;
              <p v-if="dataInfo.beginEndState == 0">视频下载（空白版）</p>
              <p v-if="dataInfo.beginEndState == 1">
                视频下载（{{
                  dataInfo.subtitle1Code != "-1" ? "标准版" : "首尾版"
                }}）
              </p>
              <p>并上传到纪念堂</p></el-button
            >
            <el-button
              v-if="dataInfo.beginEndState == 1"
              type="primary"
              class="lifeAlbum_video_download_button"
              @click="downloadLifeAlbum(3)"
            >
              &nbsp;
              <p>视频下载</p>
              <p>
                （{{
                  dataInfo.subtitle1Code != "-1"
                    ? "标准无旁白版"
                    : "首尾无旁白版"
                }}）
              </p></el-button
            >
            <el-button
              type="primary"
              class="lifeAlbum_video_download_button"
              @click="uploadPhotoToDmPhoto()"
              >&nbsp;
              <p>照片下载</p>
              <p>并上传到纪念堂</p></el-button
            >
          </div>
        </div>
      </template>
      <template v-if="stepActive == 3">
        <div class="lifeAlbum_pic_bar">
          <div class="lifeAlbum_pic_bar_title">修改照片：</div>
        </div>
        <div class="lifeAlbum_pic_content">
          <!-- 显示照片 -->
          <div class="lifeAlbum_pic_list">
            <div class="lifeAlbum_pic_list_draggable">
              <div
                class="lifeAlbum_pic_edit_list_item"
                v-for="(item, i) in picEditList"
                :key="item.id"
              >
                <div
                  class="lifeAlbum_pic_edit_list_item_content"
                  @dblclick="editPhotoFrame(item, i)"
                >
                  <img
                    class="lifeAlbum_pic_edit_list_item_bg"
                    :src="
                      item.bgUrl +
                      '?x-oss-process=image/resize,m_fill,h_135,w_240'
                    "
                  />
                  <img
                    :src="
                      item.photoUrl +
                      (item.photoUrl.indexOf('https') == 0
                        ? '?x-oss-process=image/resize,m_fill,h_' +
                          parseInt(item.photoInFrameHeight / 8) +
                          ',w_' +
                          parseInt(item.photoInFrameWidth / 8)
                        : '')
                    "
                    :style="
                      'position: absolute; top:' +
                      parseInt(item.photoInFrameY / 8) +
                      'px; left:' +
                      parseInt(item.photoInFrameX / 8) +
                      'px; width:' +
                      parseInt(item.photoInFrameWidth / 8) +
                      'px; height:' +
                      parseInt(item.photoInFrameHeight / 8) +
                      'px; background-color: #000;'
                    "
                  />
                  <!-- 上传状态图标 -->
                  <div
                    class="lifeAlbum_pic_edit_list_item_process"
                    v-if="item.progress >= 0 && item.progress <= 100"
                  >
                    <img
                      class="lifeAlbum_pic_edit_list_item_process_success"
                      v-if="item.progress == 100"
                      src="@/assets/images/space/iv_update_success.png"
                      alt=""
                    />
                    <img
                      class="lifeAlbum_pic_edit_list_item_process_failed"
                      src="@/assets/images/space/iv_update_failed.png"
                      v-if="item.progress == 0"
                      alt=""
                      @click="reuploadEditRequest(item, i)"
                    />
                    <el-progress
                      v-if="item.progress > 0 && item.progress < 100"
                      :percentage="item.progress"
                      :stroke-width="10"
                      color="#2C90FF"
                      class="lifeAlbum_pic_edit_list_item_process_bar"
                      :show-text="false"
                    ></el-progress>
                  </div>
                </div>
                <span class="lifeAlbum_pic_list_item_index">{{ i + 1 }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="lifeAlbum_pic_button">
          <el-button @click="cancelPicEdit()">取消修改</el-button>
          <el-button type="primary" @click="addLifeAlbum()"
            >确认修改并重新制作</el-button
          >
        </div>
      </template>
    </div>
    <!-- AI照片合成 -->
    <div v-if="aiPicComposite" class="lifeAlbum_pic_body">
      <div class="lifeAlbum_pic_bar">
        <div class="lifeAlbum_pic_bar_title">人物识别：</div>
        <!-- <div class="lifeAlbum_pic_bar_buttons">
          <el-button
            type="primary"
            v-show="picList.length > 0 && choicePicType == 0"
            @click="choicePhoto(2)"
            >选择合成人物</el-button
          >
          <el-button v-show="choicePicType > 0" @click="choicePhotoCancel()"
            >取消</el-button
          >
          <el-button
            type="primary"
            v-show="choicePicType > 0"
            @click="choicePhotoConfirm()"
            >确定</el-button
          >
        </div> -->
      </div>
      <div class="lifeAlbum_pic_content">
        <!-- 显示头像 -->
        <template v-if="aiPicCompositeLoadingType != 2">
          <draggable
            class="lifeAlbum_pic_list lifeAlbum_pic_composite_list"
            v-show="aiPicCompositeList.length > 0"
            v-model="aiPicCompositeList"
            :options="{
              sort: true,
              disabled: !true,
            }"
            group="compositePhotos"
          >
            <div
              class="lifeAlbum_pic_list_item lifeAlbum_pic_composite_list_item"
              v-for="(item, i) in aiPicCompositeList"
              :key="'pic_composite_' + i"
            >
              <div
                v-if="item.photoBase64"
                class="lifeAlbum_pic_list_item_content lifeAlbum_pic_composite_list_item_content"
                @click="clickChoiceCompositePhotoAi(i)"
              >
                <img :src="'data:image/png;base64,' + item.photoBase64" />
                <!-- 选中状态图标 -->
                <img
                  class="lifeAlbum_pic_list_item_choice"
                  v-if="item.checked"
                  src="@/assets/images/space/iv_choice_photo.png"
                  alt=""
                />
                <img
                  class="lifeAlbum_pic_list_item_choice"
                  v-if="!item.checked"
                  src="@/assets/images/space/iv_choice_can.png"
                  alt=""
                />
              </div>
              <!-- <el-radio v-model="aiPicInfo.radio" label="Male">女</el-radio>
              <el-radio v-model="aiPicInfo.radio" label="Female">男</el-radio>
              <el-input v-model="aiPicInfo.radio" size="mini">年龄</el-input> -->
            </div>
          </draggable>
          <!-- 风格 -->
          <!-- <div>
            <el-radio v-model="aiPicInfo.radio" label="ancient"
              >古代风格</el-radio
            >
            <el-radio v-model="aiPicInfo.radio" label="modern_home"
              >现代居家风格</el-radio
            >
          </div> -->
          <!-- 比例 -->
          <!-- <div>
            <el-radio v-model="aiPicInfo.radio" label="portrait"
              >纵向（1024×768）</el-radio
            >
            <el-radio v-model="aiPicInfo.radio" label="horizontal"
              >横向（768×1024）</el-radio
            >
          </div> -->
          <!-- 模板 -->
          <div
            class="lifeAlbum_pic_composite_template"
            v-show="aiPicCompositeTemplateUrl"
          >
            <img
              :src="aiPicCompositeTemplateUrl + '?' + new Date().getTime()"
            />
          </div>
          <!-- 顺序 -->
          <div
            class="lifeAlbum_pic_list lifeAlbum_pic_composite_list"
            v-show="aiPicCompositeTemplateList.length > 0"
          >
            <div
              class="lifeAlbum_pic_list_item lifeAlbum_pic_composite_list_item"
              v-for="(item, i) in aiPicCompositeTemplateList"
              :key="'pic_composite_template' + i"
              v-show="item"
            >
              <div
                class="lifeAlbum_pic_list_item_content lifeAlbum_pic_composite_list_item_content cursor_auto"
              >
                <img :src="'data:image/png;base64,' + item" />
              </div>
            </div>
          </div>
          <!-- 合成 -->
          <div
            class="lifeAlbum_pic_composite_template"
            v-show="aiPicCompositeUrl"
          >
            <img :src="aiPicCompositeUrl + '?' + new Date().getTime()" />
          </div>
        </template>
        <template v-if="aiPicCompositeLoadingType == 2">
          <!-- 头像 -->
          <div
            class="lifeAlbum_pic_list lifeAlbum_pic_composite_list justify_content_center"
            v-show="aiPicCompositeList.length > 0"
          >
            <div
              class="lifeAlbum_pic_list_item lifeAlbum_pic_composite_list_item"
              v-for="(item, i) in aiPicCompositeList"
              :key="'pic_composite2_' + i"
              v-show="item.photoBase64 && item.checked"
            >
              <div
                class="lifeAlbum_pic_list_item_content lifeAlbum_pic_composite_list_item_content cursor_auto"
              >
                <img :src="'data:image/png;base64,' + item.photoBase64" />
              </div>
            </div>
          </div>
        </template>
        <div
          v-if="aiPicCompositeLoading"
          class="lifeAlbum_pic_composite_loading"
        >
          <span>{{
            aiPicCompositeLoadingType == 2 ? "AI照片合成中" : "人物识别中"
          }}</span>
          <img src="@/assets/images/OauthApply/loading.gif" alt="" />
        </div>
      </div>
      <div class="lifeAlbum_pic_button" v-if="!aiPicCompositeLoading">
        <el-button type="primary" @click="callPhotoAi(4)">生成模板</el-button>
        <el-button type="primary" @click="callPhotoAi(5)">模板头像</el-button>
        <el-button type="primary" @click="callPhotoAi(6)">确认合成</el-button>
      </div>
    </div>
    <div style="margin-bottom: 30px"></div>
    <!-- 修改照片 -->
    <el-dialog
      class="dialog_cut_image"
      title="图片剪裁"
      width="1350px"
      top="2vh"
      :visible.sync="cropperDialog"
      :close-on-click-modal="false"
      :before-close="editPhotoFrameCancel"
      append-to-body
    >
      <div class="cropper-content" style="height: 665px">
        <div
          class="cropper"
          style="
            text-align: center;
            width: 1920px;
            height: 1080px;
            float: left;
            zoom: 0.6;
          "
        >
          <vueCropper
            ref="cropper"
            :img="cropperOption.img"
            :outputSize="cropperOption.size"
            :outputType="cropperOption.outputType"
            :info="cropperOption.info"
            :canMove="cropperOption.canMove"
            :canMoveBox="cropperOption.canMoveBox"
            :original="cropperOption.original"
            :autoCrop="cropperOption.autoCrop"
            :fixed="cropperOption.fixed"
            :centerBox="cropperOption.centerBox"
            :infoTrue="cropperOption.infoTrue"
            :fixedBox="cropperOption.fixedBox"
            :autoCropWidth="cropperOption.autoCropWidth"
            :autoCropHeight="cropperOption.autoCropHeight"
            :high="false"
          ></vueCropper>
        </div>
        <div
          class="size_btns"
          style="
            flex-direction: column;
            display: flex;
            float: left;
            margin-left: 40px;
          "
        >
          <el-button
            type="text"
            v-for="(item, i) in photoFrameSizeArray"
            :key="i"
            :style="
              item.photoFrameName == cropperOption.photoFrameName
                ? 'color:#409EFF;'
                : 'color:#000000;'
            "
            @click="photoFrameSizeClick(item)"
            >{{
              item.photoInFrameWidth + "×" + item.photoInFrameHeight
            }}</el-button
          >
          <el-button
            type="primary"
            @click="editPhotoFrameConfirm()"
            style="width: 100px; margin-top: 30px"
            >确 认</el-button
          >
          <el-button
            @click="editPhotoFrameCancel()"
            style="width: 100px; margin-top: 30px"
            >取 消</el-button
          >
        </div>
      </div>
    </el-dialog>
    <!-- AI照片优化查看与替换 -->
    <template v-if="aiPicInfo.show">
      <!-- <div class="lifeAlbum_pic_ai_replace_modal"></div>
      <div class="lifeAlbum_pic_ai_replace">
        <div class="lifeAlbum_pic_ai_replace_content">
          <div
            class="lifeAlbum_pic_ai_replace_content_item"
            @click="replacePhotoAiUrlCheck('1')"
          >
            <img :src="aiPicInfo.url" />
            <el-radio v-model="aiPicInfo.radio" label="1">优化前</el-radio>
          </div>
          <div
            class="lifeAlbum_pic_ai_replace_content_item"
            @click="replacePhotoAiUrlCheck('2')"
          >
            <img
              class="lifeAlbum_pic_ai_replace_close"
              src="@/assets/images/video/iv_close.png"
              @click="replacePhotoAiUrlHide()"
            />
            <img :src="aiPicInfo.aiUrl" />
            <el-radio v-model="aiPicInfo.radio" label="2">优化后</el-radio>
            <div
              class="lifeAlbum_pic_ai_download"
              @click.stop="downloadPhotoAi(aiPicInfo.aiUrl)"
            >
              <p>下载</p>
            </div>
          </div>
        </div>
        <div class="lifeAlbum_pic_ai_replace_button">
          <el-button type="primary" @click="replacePhotoAiUrl()"
            >确定</el-button
          >
        </div>
      </div> -->
      <div class="lifeAlbum_pic_ai_edit_modal"></div>
      <div class="lifeAlbum_pic_ai_edit_loading" v-show="aiPicLoadingShow">
        <img src="@/assets/images/space/photo_loading.png" />
      </div>
      <div
        class="lifeAlbum_pic_ai_edit_content_item_loading"
        v-show="aiPicItemLoadingShow"
      ></div>
      <div class="lifeAlbum_pic_ai_edit">
        <div class="lifeAlbum_pic_ai_edit_content" id="aiPicContent">
          <div class="lifeAlbum_pic_ai_edit_content_bar">
            <span v-if="!aiPicCropperShow" @click="replacePhotoAiUrlHide()"
              >取消</span
            >
            <span v-if="aiPicCropperShow" @click="aiPicCropperReturnClick()"
              >取消</span
            >
            <span @click="aiPicEditConfirm()">确定</span>
          </div>
          <div
            class="lifeAlbum_pic_ai_edit_content_navigation"
            v-if="!aiPicCropperShow"
          >
            <img
              src="@/assets/images/space/iv_advance_white.png"
              v-show="aiPicItemPrevShow"
              @click="replacePhotoAiUrlPrev()"
            />
            <img
              src="@/assets/images/space/iv_retreat_white.png"
              v-show="aiPicItemNextShow"
              @click="replacePhotoAiUrlNext()"
            />
          </div>
          <div class="lifeAlbum_pic_ai_edit_content_item">
            <!-- <img
              v-show="!aiPicCropperShow"
              class="lifeAlbum_pic_ai_edit_close"
              src="@/assets/images/video/iv_close.png"
              @click="replacePhotoAiUrlHide()"
            /> -->
            <div
              @mousemove="aiPicMouseMove"
              @mouseleave="aiPicMouseLeave"
              id="aiPicContentItem"
            >
              <div
                class="lifeAlbum_pic_ai_edit_content_item_loading_pic"
                v-show="aiPicItemLoadingShow"
              >
                <img src="@/assets/images/space/photo_loading.png" />
              </div>
              <div class="lifeAlbum_pic_ai_edit_img" id="aiPicImgOld">
                <img
                  :src="aiPicInfo.url"
                  :key="aiPicInfo.urlKey"
                  @load="aiPicLoad"
                />
              </div>
              <div class="lifeAlbum_pic_ai_edit_img" id="aiPicImgNew">
                <img
                  :src="aiPicInfo.aiUrl"
                  :key="aiPicInfo.aiUrlKey"
                  @load="aiPicLoad"
                />
              </div>
              <div
                class="lifeAlbum_pic_ai_edit_slider"
                id="aiPicSlider"
                style="display: none"
              >
                <div
                  class="lifeAlbum_pic_ai_edit_slider_line"
                  style="height: 80%"
                ></div>
                <div class="lifeAlbum_pic_ai_edit_slider_handle">
                  <div class="lifeAlbum_pic_ai_edit_slider_left_arrow"></div>
                  <div class="lifeAlbum_pic_ai_edit_slider_right_arrow"></div>
                  <span class="lifeAlbum_pic_ai_edit_slider_handle_span_before"
                    >优化前</span
                  >
                  <span class="lifeAlbum_pic_ai_edit_slider_handle_span_after"
                    >优化后</span
                  >
                </div>
                <div
                  class="lifeAlbum_pic_ai_edit_slider_line"
                  style="height: 20%"
                ></div>
              </div>
            </div>
            <div id="aiPicCropper" style="display: none; position: relative">
              <!-- <vueCropper
                ref="aiPicCropperRef"
                :img="cropperOption.img"
                :outputSize="cropperOption.size"
                :outputType="cropperOption.outputType"
                :info="cropperOption.info"
                :canMove="cropperOption.canMove"
                :canMoveBox="cropperOption.canMoveBox"
                :original="cropperOption.original"
                :autoCrop="cropperOption.autoCrop"
                :fixed="cropperOption.fixed"
                :centerBox="cropperOption.centerBox"
                :infoTrue="cropperOption.infoTrue"
                :fixedBox="cropperOption.fixedBox"
                :autoCropWidth="cropperOption.autoCropWidth"
                :autoCropHeight="cropperOption.autoCropHeight"
                :high="false"
                :rotatable="true"
                @imgLoad="aiPicCropperImgLoad"
              ></vueCropper> -->
              <vueCropperAngle
                v-show="!aiPicAngleShow"
                ref="aiPicCropperRef"
                :cropperOption="cropperOption"
              ></vueCropperAngle>
              <div
                class="lifeAlbum_pic_ai_edit_angle_img"
                v-show="aiPicAngleShow"
              >
                <img
                  :src="aiPicAngleUrl"
                  id="aiPicAngleImg"
                  @load="aiPicAngleLoad"
                />
              </div>
              <div
                class="lifeAlbum_pic_ai_edit_angle"
                v-show="aiPicAngleShow"
                id="aiPicAngle"
              >
                <div
                  class="lifeAlbum_pic_ai_edit_angle_item"
                  style="left: 0"
                  id="aiPicAngleItem"
                  @mousedown="aiPicAngleMouseDown"
                >
                  <div
                    v-for="num in 31"
                    :key="'lifeAlbum_pic_ai_edit_angle_item' + num"
                    :style="(num - 1) % 5 == 0 ? 'width: 4px; height: 4px' : ''"
                  >
                    <span>{{
                      (num - 1) % 5 == 0 ? -45 + (num - 1) * 3 + "°" : ""
                    }}</span>
                  </div>
                </div>
                <div class="lifeAlbum_pic_ai_edit_angle_pointer"></div>
                <div
                  class="lifeAlbum_pic_ai_edit_angle_left_svg"
                  @click="aiPicAngleRotateLeft()"
                >
                  <svg width="28" height="28" fill="none">
                    <g
                      clip-path="url(#4ladfx-a)"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path
                        d="M24.52 9.04H12.06a2.48 2.48 0 0 0-2.48 2.48v9A2.48 2.48 0 0 0 12.06 23h12.46A2.48 2.48 0 0 0 27 20.52v-9a2.48 2.48 0 0 0-2.48-2.48ZM10.04 5c-4.79 1.3-7.6 6.15-6.28 10.85"
                      ></path>
                      <path d="m1 13.79 2.53 3.28 2.45-3.42"></path>
                    </g>
                    <defs>
                      <clipPath id="4ladfx-a">
                        <path
                          fill="#fff"
                          transform="translate(0 4)"
                          d="M0 0h28v20H0z"
                        ></path>
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div
                  class="lifeAlbum_pic_ai_edit_angle_right_svg"
                  @click="aiPicAngleRotateRight()"
                >
                  <svg width="28" height="28" fill="none">
                    <g
                      clip-path="url(#0byvp1-a)"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path
                        d="M3.48 23h12.46a2.48 2.48 0 0 0 2.48-2.48v-9a2.48 2.48 0 0 0-2.48-2.48H3.48A2.48 2.48 0 0 0 1 11.52v9A2.48 2.48 0 0 0 3.48 23ZM17.96 5c4.79 1.3 7.6 6.15 6.28 10.85"
                      ></path>
                      <path d="m27 13.79-2.53 3.28-2.45-3.42"></path>
                    </g>
                    <defs>
                      <clipPath id="0byvp1-a">
                        <path
                          fill="#fff"
                          transform="translate(0 4)"
                          d="M0 0h28v20H0z"
                        ></path>
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </div>
            </div>
            <div class="lifeAlbum_pic_ai_edit_button">
              <template v-if="aiPicCropperShow">
                <p v-show="false" @click="aiPicCropperReturnClick">返回</p>
                <p
                  v-show="false"
                  class="lifeAlbum_pic_ai_edit_button_reset"
                  @click="aiPicCropperResetClick"
                >
                  重置
                </p>
              </template>
              <template v-else>
                <!-- <p @click="callPhotoAi(2)">上色</p>
                <p @click="callPhotoAi(3)">去折痕</p> -->
                <p @click="aiPicCropperClick(1)">裁剪</p>
                <p @click="aiPicCropperClick(2)">调整角度</p>
                <p
                  v-show="aiPicInfo.url"
                  @click="downloadPhotoAi(aiPicInfo.aiUrl)"
                  class="lifeAlbum_pic_ai_edit_button_download"
                >
                  优化下载
                </p>
                <p
                  :class="
                    'lifeAlbum_pic_ai_edit_button_reset' +
                    (this.aiPicInfo.aiUrlOriginal == this.aiPicInfo.aiUrl
                      ? ' disable'
                      : '')
                  "
                  @click="aiPicResetClick"
                >
                  全部重置
                </p>
              </template>
            </div>
          </div>
        </div>
        <!-- <div class="lifeAlbum_pic_ai_edit_button_confirm">
          <el-button type="primary" @click="aiPicEditConfirm()">确定</el-button>
        </div> -->
      </div>
    </template>
    <!-- 模板查看 -->
    <el-drawer
      class="lifeAlbum_template_view_drawer"
      :visible.sync="templateViewShow"
      :title="templateViewTitle"
      :before-close="viewLifeAlbumTemplateClose"
      :modal="false"
      :show-close="false"
      size="70%"
    >
      <el-button
        type="primary"
        class="lifeAlbum_template_view_button"
        @click="clickTemplateViewButton()"
        >确定</el-button
      >
      <div v-if="templateViewType == 1" class="lifeAlbum_template_view_flex">
        <div
          class="lifeAlbum_template_view_bg"
          v-for="(item, index) in templateViewList"
          :key="'templateView' + index"
          @click="clickTemplateViewRadio(item.code)"
        >
          <img :src="item.remark" />
          <el-radio
            class="lifeAlbum_template_view_radio"
            v-model="templateViewRadio"
            :label="item.code"
            >{{ item.content }}</el-radio
          >
        </div>
      </div>
      <div v-if="templateViewType == 2" class="lifeAlbum_template_view_flex">
        <div
          class="lifeAlbum_template_view_music"
          v-for="(item, index) in templateViewList"
          :key="'templateView' + index"
          @click="clickTemplateViewRadio(item.code)"
          @dblclick="playLifeAlbumTemplateMusic(item.isPlay, index)"
        >
          <img
            class="lifeAlbum_template_view_music_bg"
            src="@/assets/images/space/music-bg.png"
          />
          <template v-if="item.isPlay">
            <img
              class="lifeAlbum_template_view_music_button"
              src="@/assets/images/space/iv_music_play.png"
            />
            <div class="lifeAlbum_template_view_music_text">双击暂停</div>
          </template>
          <template v-if="!item.isPlay">
            <img
              class="lifeAlbum_template_view_music_button"
              src="@/assets/images/space/iv_music_stop.png"
            />
            <div class="lifeAlbum_template_view_music_text">双击试听</div>
          </template>
          <el-radio
            class="lifeAlbum_template_view_radio"
            v-model="templateViewRadio"
            :label="item.code"
            >{{ item.content }}</el-radio
          >
        </div>
        <audio id="lifeAlbumTemplateMusicAudio"></audio>
      </div>
      <div v-if="templateViewType == 3" class="lifeAlbum_template_view_flex">
        <div
          class="lifeAlbum_template_view_subtitle"
          v-for="(item, index) in templateViewList"
          :key="'templateView' + index"
          @click="clickTemplateViewRadio(item.code)"
        >
          <el-radio
            class="lifeAlbum_template_view_radio"
            v-model="templateViewRadio"
            :label="item.code"
            >{{ item.content }}</el-radio
          >
          <pre>{{ item.remark }}</pre>
        </div>
      </div>
      <div v-if="templateViewType == 4" class="lifeAlbum_template_view_flex">
        <div
          class="lifeAlbum_template_view_subtitle"
          v-for="(item, index) in templateViewList"
          :key="'templateView' + index"
          @click="clickTemplateViewRadio(item.code)"
        >
          <el-radio
            class="lifeAlbum_template_view_radio"
            v-model="templateViewRadio"
            :label="item.code"
            >{{ item.content }}</el-radio
          >
          <pre>{{ item.remark }}</pre>
        </div>
      </div>
      <div v-if="templateViewType == 5" class="lifeAlbum_template_view_flex">
        <div
          class="lifeAlbum_template_view_subtitle"
          v-for="(item, index) in templateViewList"
          :key="'templateView' + index"
          @click="clickTemplateViewRadio(item.code)"
        >
          <el-radio
            class="lifeAlbum_template_view_radio"
            v-model="templateViewRadio"
            :label="item.code"
            >{{ item.content }}</el-radio
          >
          <pre>{{ item.remark }}</pre>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import mixins from "./Mixins";
import draggable from "vuedraggable";
import axios from "axios";
const OSS = require("ali-oss");
import {
  catchErr,
  roundAll,
  nowDate,
  seconds,
  OSSUrl,
  localUrl,
  updataLink,
} from "@/utils/utils";
import vueCropperAngle from "@/components/VueCropperAngle";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import imageCompression from "browser-image-compression";
export default {
  components: {
    draggable,
    vueCropperAngle,
  },
  mixins: [mixins],
  data() {
    return {
      //人生相册
      pageModal: true,
      pageModalText: "",
      dmId: null,
      dataInfo: {},
      stepActive: 0,
      picList: [],
      picIndex: 0,
      picMap: {},
      uploadIndex: -1, //执行上传位置，用作于替换
      uploadLimitMax: 46,
      uploadOssCreateTime: 0,
      picListCopy: [],
      choicePicType: 0, //1删除，2AI照片合成，3照片优化，4去除折痕
      choicePicCount: 0,
      isCanDrag: true,
      photoOptionsIndex: -1, //照片更多选项
      aiPicInfo: {
        show: false,
        index: -1,
        id: -1,
        radio: -1,
        url: "",
        aiUrl: "",
      },
      aiPicAngleNum: 0,
      aiPicAngleNum90: 0,
      aiPicAngleLeft: null,
      aiPicCropperShow: false,
      aiPicAngleShow: false,
      aiPicAngleUrl: null,
      aiPicLoadCount: 0,
      aiPicLoadingShow: true,
      aiPicItemLoadingShow: false,
      aiPicItemPrevShow: false,
      aiPicItemNextShow: false,
      templateBgList: [],
      templateMusicList: [],
      templateSubtitle1List: [],
      templateSubtitle2List: [],
      templateSubtitle3List: [],
      templateSubtitleShow: true,
      templateSubtitleRequired: true,
      templateSubtitleDisabled: false,
      templateViewShow: false,
      templateViewTitle: "",
      templateViewType: 0,
      templateViewList: [],
      templateMusicPlay: false,
      templateViewRadio: "",
      videoProcess: 0,
      videoProcessText: "",
      videoProcessButton: 0,
      videoShow: false,
      videoListener: false,
      picEditList: [],
      picEditIndex: 0,
      existPhotoAi: false,
      showPhotoAiAllButton: false,
      cropperDialog: false,
      cropperOption: {
        img: "", // 裁剪图片的地址
        info: false, // 裁剪框的大小信息
        outputSize: 0.8, // 裁剪生成图片的质量
        outputType: "jpeg", // 裁剪生成图片的格式
        canScale: false, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 100, // 默认生成截图框宽度
        autoCropHeight: 100, // 默认生成截图框高度
        fixedBox: true, // 固定截图框大小 不允许改变
        fixed: false, // 是否开启截图框宽高固定比例
        fixedNumber: [7, 5], // 截图框的宽高比例
        full: true, // 是否输出原图比例的截图
        canMoveBox: false, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: false, // 截图框是否被限制在图片里面
        infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        imgLoad: {}, //图片加载完毕回调
      },
      photoFrameSizeArray: [],
      createVideoType: 1, //1预览、2有旁白、3无旁白、4照片
      downloadVideoUrl: "",
      aiPicComposite: false,
      aiPicCompositeList: [],
      aiPicCompositeLoading: false,
      aiPicCompositeLoadingType: 0, //1头像、2合成
      aiPicCompositeTemplateUrl: "",
      aiPicCompositeTemplateList: [],
      aiPicCompositeUrl: "",
    };
  },
  computed: {
    OSSInfo() {
      let data = {
        ...this.Common.OSSINFONew,
        fileName: this.Common.FileName,
      };
      return data;
    },
    photoAlbumDetails: {
      get: function () {
        return this.SpaceManagement.spaceDetails.photoAlbumDetails;
      },
      set: function (v) {
        this.PHOTOALBUMDETAILS(v);
      },
    },
  },
  created() {
    this.dmId = this.$route.query.id;
    this.validateLocalService();
  },
  mounted() {},
  watch: {},
  methods: {
    //验证本地服务
    validateLocalService() {
      axios({
        method: "GET",
        url: localUrl() + "bygLifeAlbum/getSystemInfo",
        responseType: "json",
      })
        .then((res) => {
          res = res.data;
          if (res.status == 1000) {
            this.getDataInfo();
          } else {
            this.pageModalText = "获取信息失败，请检查本地服务是否启动";
          }
        })
        .catch((err) => {
          this.pageModalText = "获取信息失败，请检查本地服务是否启动";
        });
    },
    //获取人生相册
    getDataInfo() {
      this.pageModal = false;
      this.getLifeAlbumByDmId(this.dmId).then((res) => {
        if (res.status == 1000) {
          if (res.data) {
            this.dataInfo = res.data;
            if (this.dataInfo.beginEndState == 0) {
              this.templateSubtitleRequired = false;
              this.templateSubtitleDisabled = true;
            }
            this.lifeAlbumStepClick(res.data.state, false, true);
            if (res.data.state == 3) {
              this.videoShow = true;
            }
          } else {
            this.lifeAlbumStepClick(1);
          }
        }
      });
    },
    //获取人生相册照片
    getPicList(reload) {
      if (this.picList.length == 0 || reload) {
        let params = {
          dmId: this.dmId,
        };
        this.findLifeAlbumPhotoAllByDmId(params).then((res) => {
          if (res.status == 1000) {
            this.setExistPhotoAi(res.data);
            this.picList = res.data;
          }
        });
      }
    },
    //获取背景模板
    getTemplateBgList() {
      if (this.templateBgList.length == 0) {
        this.findLifeAlbumTemplateBg().then((res) => {
          if (res.status == 1000) {
            this.templateBgList = res.data;
          }
        });
      }
    },
    //获取音乐模板
    getTemplateMusicList() {
      if (this.templateMusicList.length == 0) {
        this.findLifeAlbumTemplateMusic().then((res) => {
          if (res.status == 1000) {
            this.templateMusicList = res.data;
          }
        });
      }
    },
    //获取字幕模板1-人生角色
    getTemplateSubtitle1List() {
      if (this.templateSubtitle1List.length == 0) {
        this.findLifeAlbumSubtitle1().then((res) => {
          if (res.status == 1000) {
            this.templateSubtitle1List = res.data;
          }
        });
      }
    },
    //获取字幕模板2-人才类型
    getTemplateSubtitle2List() {
      if (this.templateSubtitle2List.length == 0) {
        this.findLifeAlbumSubtitle2().then((res) => {
          if (res.status == 1000) {
            this.templateSubtitle2List = res.data;
          }
        });
      }
    },
    //获取字幕模板3-天命
    getTemplateSubtitle3List() {
      if (this.templateSubtitle3List.length == 0) {
        this.findLifeAlbumSubtitle3().then((res) => {
          if (res.status == 1000) {
            this.templateSubtitle3List = res.data;
          }
        });
      }
    },
    //步骤导航点击
    lifeAlbumStepClick(index, step, init) {
      if (step) {
        if (this.stepActive <= index - 1) {
          if (index == 1) {
            this.aiPicComposite = false;
          }
          return;
        }
        if (index == 1 || index == 2) {
          this.cleanLifeAlbum(index);
        } else if (index == 3) {
          this.cancelPicEdit();
        }
      } else {
        this.videoListener = false;
        if (index == 1) {
          this.getPicList();
        } else if (index == 2) {
          this.getTemplateBgList();
          this.getTemplateMusicList();
          this.getTemplateSubtitle1List();
          this.getTemplateSubtitle2List();
          this.getTemplateSubtitle3List();
        } else if (index == 3) {
          this.stepActive = index - 1;
          return;
        } else if (index == 4) {
          this.getPicEditList();
        }

        if (init) {
          this.stepActive = index - 1;
          if (index == 4) {
            this.lifeAlbumStepStyleBlack();
          }
        } else {
          let params = {
            dmId: this.dmId,
            state: index,
          };
          this.updateLifeAlbumStateByDmId(params).then((res) => {
            if (res.status == 1000) {
              this.stepActive = index - 1;
              if (index == 4) {
                this.lifeAlbumStepStyleBlack();
              }
            }
          });
        }
      }
    },
    lifeAlbumStepStyleBlack() {
      this.$nextTick(() => {
        let obj8 = document.getElementsByClassName("is-success")[8];
        let obj7 = document.getElementsByClassName("is-success")[7];
        let obj6 = document.getElementsByClassName("is-success")[6];
        obj8.classList.replace("is-success", "is-process");
        obj7.classList.replace("is-success", "is-process");
        obj6.classList.replace("is-success", "is-process");
        let obj = document.getElementsByClassName("is-status el-icon-check")[2];
        obj.classList.remove("el-icon-check");
        obj.innerHTML = 3;
        obj = document.getElementsByClassName("el-step__line-inner")[1];
        obj.style.width = "0%";
      });
    },
    //设置OSS签名
    initOSSsignature(callback) {
      let result = true;
      if ((new Date() - this.uploadOssCreateTime) / 1000 > 600) {
        this.uploadOssCreateTime = new Date();
        this.getOSSsignature({}).then((res) => {
          if (res && callback) {
            callback();
          }
        });
        result = false;
      }
      return result;
    },
    //上传文件
    triggerUploadButton() {
      if (!this.validateState(1)) {
        return;
      }
      if (this.initOSSsignature(this.triggerUploadButton)) {
        this.uploadIndex = -1;
        this.$refs.upLoadButton.$el.querySelector('input[type="file"]').click();
      }
    },
    uploadLimit() {
      this.$message.error("超过最大可上传数量，可删除后再上传");
    },
    uploadBefore(file) {
      //console.log("uploadBefore");
      let that = this;
      if (file.type == "image/jpeg" || file.type == "image/png") {
        if (file.size / 1024 > 20 * 1024) {
          that.$message.error("照片大小已超出20MB");
          return false;
        }
      } else {
        that.$message.error("上传照片格式限制为jpg或png");
        return false;
      }
      if (that.uploadIndex >= 0) {
        that.picIndex = that.uploadIndex;
        that.picList.splice(that.picIndex, 1);
      } else {
        that.picIndex = that.picList.length;
      }
      that.picMap[file.uid] = that.picIndex;
      let data = {
        progress: 0.01,
        file: file,
      };
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = function () {
        data.photoUrl = this.result;
      };
      that.picList.splice(that.picIndex, 0, data);
      return true;
    },
    uploadProcess(event, file, fileList) {
      //console.log("uploadProcess");
    },
    uploadSuccess(res, file, fileList) {
      //console.log("uploadSuccess");
    },
    uploadError(res, file, fileList) {
      //console.log("uploadError");
    },
    uploadExceed(files, fileList) {
      //console.log("uploadExceed", fileList);
      this.$message.error("超过可上传数量，请重新选择");
    },
    uploadChange(file, fileList) {
      //console.log("handFileChange");
    },
    uploadRequest(params) {
      //console.log("uploadRequest-OSS", params);
      this.multipartUpload(
        params.file,
        this.uploadRequestProgress,
        this.uploadRequestFinish
      );
    },
    uploadRequestProgress(picIndex, progress) {
      this.picList[picIndex].progress = progress;
    },
    uploadRequestFinish(picIndex, photoUrl) {
      this.picList[picIndex].photoUrl = photoUrl;
      this.picList[picIndex].photoUrlSource = photoUrl;
      this.addPicList(picIndex);
    },
    async multipartUpload(file, progressCallback, finishCallback) {
      let that = this;
      let picIndex = that.picMap[file.uid];
      let _file = file;
      try {
        //压缩文件
        // if (_file.size / 1024 > 2 * 1024) {
        //   const options = {
        //     maxSizeMB: 2, // 最大文件大小（MB）
        //     maxWidthOrHeight: 1920, // 最大宽度或高度
        //     useWebWorker: true, // 使用 Web Worker 加速
        //   };
        //   _file = await imageCompression(_file, options);
        // }
        //上传文件
        let client = new OSS({
          region: this.OSSInfo.region,
          accessKeyId: this.OSSInfo.accessKeyId,
          accessKeySecret: this.OSSInfo.accessKeySecret,
          stsToken: this.OSSInfo.securityToken,
          bucket: this.OSSInfo.bucket,
          endpoint: this.OSSInfo.endpoint,
          cname: this.OSSInfo.cname,
        });
        let fileName =
          new Date().getTime() +
          "" +
          (Math.floor(Math.random() * 900000) + 100000) +
          _file.name.substring(_file.name.lastIndexOf("."));
        const result = await client.multipartUpload(
          `${updataLink()}space/${that.dmId}/lifeAlbum/slial_` + fileName,
          _file,
          {
            progress: function (p, checkpoint) {
              let progress = p < 0.01 ? 0.01 : p;
              progress = progress > 0.99 ? 0.99 : progress;
              progressCallback(picIndex, progress * 100);
            },
            partSize: 1024 * 1024,
          }
        );
        finishCallback(
          picIndex,
          OSSUrl() + result.name,
          parseInt(_file.size / 1024)
        );
      } catch (e) {
        console.log(picIndex, e);
        if (that.picList.length > picIndex) {
          that.picList[picIndex].progress = 0;
        }
        if (that.picEditList.length > picIndex) {
          that.picEditList[picIndex].progress = 0;
        }
        this.initOSSsignature();
      }
    },
    reuploadRequest(picItem, picIndex) {
      this.picList[picIndex].progress = 0.01;
      if (picItem.photoUrl.indexOf("https") == 0) {
        this.addPicList(picIndex);
      } else {
        this.uploadRequest(picItem);
      }
    },
    //添加人生相册照片
    addPicList(picIndex) {
      let that = this;
      let data = {
        dmId: this.dmId,
        photoUrl: this.picList[picIndex].photoUrl,
        size: parseInt(this.picList[picIndex].file.size / 1024),
        sort: picIndex,
      };
      this.addLifeAlbumPhotoByDmId(data).then((res) => {
        //console.log("addPicList=>", res);
        if (res.status == 1000) {
          that.picList[picIndex].id = res.data;
          that.picList[picIndex].progress = 100;
          setTimeout(() => {
            that.picList[picIndex].progress = 999;
          }, 500);
        } else {
          that.picList[picIndex].progress = 0;
        }
        that.setExistPhotoAi(that.picList);
      });
    },
    // 拖动
    draggableStart(e) {
      //console.log("draggableStart=>", e);
      this.picListCopy = JSON.parse(JSON.stringify(this.picList));
    },
    draggableEnd(e) {
      //console.log("draggableEnd=>", e);
      if (e.newIndex != e.oldIndex) {
        this.isCanDrag = false;
        let params = {
          id: this.picListCopy[e.oldIndex].id,
          dmId: this.dmId,
          newIndex: e.newIndex,
          oldIndex: e.oldIndex,
        };
        this.draggableLifeAlbumPhoto(params).then((res) => {
          //console.log("draggableEnd=>", res);
          if (res.status == 1000) {
            this.$message.success("操作成功");
          } else {
            this.picList = this.picListCopy;
          }
          this.isCanDrag = true;
        });
      }
    },
    draggableMove(e) {
      //console.log("draggableMove=>", e);
      return (
        this.choicePicType == 0 &&
        e.draggedContext.element.id > 0 &&
        this.validateState() &&
        this.isCanDrag
      );
    },
    //验证状态
    validateState(type, currIndex) {
      let result = 0;
      this.picList.some((item, index) => {
        if (currIndex == undefined || currIndex == index) {
          if (
            (type == undefined || type == 1) &&
            item.progress > 0 &&
            item.progress < 100
          ) {
            result = 1;
            return true;
          }
          if (
            (type == undefined || type == 2) &&
            item.aiProgress > 0 &&
            item.aiProgress < 100
          ) {
            result = 2;
            return true;
          }
        }
      });
      if (result == 1) {
        this.$message.closeAll();
        this.$message.error("请等待照片上传完成，再执行操作");
      } else if (result == 2) {
        this.$message.closeAll();
        this.$message.error("请等待照片优化完成，再执行操作");
      }
      return result == 0;
    },
    //照片更多选项
    clickPhotoOptions(index) {
      if (this.photoOptionsIndex != index) {
        this.photoOptionsIndex = index;
      } else {
        this.closePhotoOptions();
      }
    },
    closePhotoOptions() {
      this.photoOptionsIndex = -1;
    },
    //替换照片
    replacePhotoByIds(index) {
      if (index != undefined) {
        this.uploadIndex = index;
      }
      if (this.initOSSsignature(this.replacePhotoByIds)) {
        this.$refs.replaceButton.$el
          .querySelector('input[type="file"]')
          .click();
      }
    },
    //选择照片
    choicePhoto(type) {
      if (!this.validateState()) {
        return;
      }
      this.choicePicType = type;
    },
    choicePhotoAll() {
      if (!this.validateState()) {
        return;
      }
      this.picList.forEach((item, index) => {
        if (!item.checked) {
          item.checked = true;
          this.choicePicCount = this.choicePicCount + 1;
          this.$set(this.picList, index, this.picList[index]);
        }
      });
    },
    //选择取消
    choicePhotoCancel() {
      this.choicePicCount = 0;
      this.picList.forEach((item) => {
        if (item.checked) {
          item.checked = false;
        }
      });
      this.choicePicType = 0;
    },
    //选择确认
    choicePhotoConfirm() {
      if (this.choicePicType == 1) {
        //删除照片
        this.delPhotoByIds();
      } else if (this.choicePicType == 2) {
        //AI照片合成
        this.compositePhotoAiShow();
      } else if (this.choicePicType == 3) {
        //照片优化
        this.editPhotoAiUrl();
      }
    },
    //选择点击
    clickChoicePhoto(index) {
      if (this.choicePicType == 0) {
        return;
      }
      if (this.picList[index].checked) {
        this.picList[index].checked = false;
        this.choicePicCount = this.choicePicCount - 1;
      } else {
        this.picList[index].checked = true;
        this.choicePicCount = this.choicePicCount + 1;
      }
    },
    //删除照片
    delPhotoByIds(delItem, delIndex) {
      let indexs = [];
      let ids = [];
      if (delItem == undefined) {
        this.picList.forEach((item, i) => {
          if (item.checked) {
            indexs.push(i);
            ids.push(item.id);
          }
        });
      } else {
        indexs.push(delIndex);
        ids.push(delItem.id);
      }
      if (ids.length > 0) {
        this.$confirm("确认删除所选照片吗？", "提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            this.callDelPhotoByIds(ids, indexs);
          })
          .catch(() => {});
      } else {
        this.$message.error("请选择照片");
      }
    },
    callDelPhotoByIds(ids, indexs) {
      this.delLifeAlbumPhotoByIds(ids).then((res) => {
        if (res.status == 1000 && indexs) {
          this.$message.success("操作成功");
          for (let i = indexs.length - 1; i >= 0; i--) {
            this.picList.splice(indexs[i], 1);
          }
          this.choicePhotoCancel();
          this.setExistPhotoAi(this.picList);
        }
      });
    },
    //照片一键优化
    editPhotoAiUrlAll() {
      if (!this.validateState()) {
        return;
      }
      this.picList.forEach((item, i) => {
        if (!item.aiUrlCount) {
          item.checked = true;
        }
      });
      //照片优化
      this.editPhotoAiUrl();
    },
    //照片优化
    editPhotoAiUrl(item, i) {
      //if (!this.validateState()) {
      //  return;
      //}
      let dataList = [];
      if (item) {
        this.picList[i].aiProgress = 0.01;
        dataList.push({
          index: i,
          id: item.id,
          dmId: this.dmId,
          photoUrl: item.photoUrl,
          aiUrlCount: item.aiUrlCount ? item.aiUrlCount : 0,
        });
        this.editPhotoAiUrlTimer(dataList);
      } else {
        this.picList.forEach((data, i) => {
          if (data.checked) {
            data.aiProgress = 0.01;
            dataList.push({
              index: i,
              id: data.id,
              dmId: this.dmId,
              photoUrl: data.photoUrl,
              aiUrlCount: data.aiUrlCount ? data.aiUrlCount : 0,
            });
          }
        });
        if (dataList.length > 0) {
          this.editPhotoAiUrlTimer(dataList);
        } else {
          this.$message.error("请选择照片");
          return;
        }
      }
      this.choicePhotoCancel();
    },
    editPhotoAiUrlTimer(dataList) {
      this.editLifeAlbumPhotoAiUrl(dataList).then((res) => {
        if (res.status == 1000) {
          let run = false;
          res.data.forEach((item) => {
            if (item.runState == 0 || item.runState == 1) {
              run = true;
            } else if (item.runState == 2) {
              this.picList[item.index].photoUrlSource =
                this.picList[item.index].photoUrl;
              this.picList[item.index].photoUrl = item.aiUrl;
              this.picList[item.index].aiUrl = item.aiUrl;
              this.picList[item.index].aiUrlCount = item.aiUrlCount;
              this.picList[item.index].aiProgress = 100;
            } else if (item.runState == 3) {
              this.picList[item.index].aiProgress = 0;
            }
            this.$set(this.picList, item.index, this.picList[item.index]);
            this.setExistPhotoAi(this.picList);
          });
          if (run) {
            setTimeout(() => {
              this.editPhotoAiUrlTimer(res.data);
            }, 5000);
          }
        } else {
          dataList.forEach((item) => {
            if (
              this.picList[item.index].aiProgress > 0 &&
              this.picList[item.index].aiProgress < 100
            ) {
              this.picList[item.index].aiProgress = 0;
            }
          });
          this.$set(this.picList, this.picList);
        }
      });
    },
    //照片优化查看
    aiPicLoad(event) {
      this.aiPicLoadCount++;
      console.log("aiPicLoad:", this.aiPicLoadCount);
      if (!this.aiPicInfo.url || this.aiPicLoadCount >= 2) {
        let aiPicContent =
          document.getElementById("aiPicContent").parentElement;
        aiPicContent.style.display = "flex";
        let aiPicContentItem = document.getElementById("aiPicContentItem");
        if (!aiPicContentItem.style.width) {
          let aiPicImgNew = document.getElementById("aiPicImgNew");
          let aiPicImgNewRect = aiPicImgNew.getBoundingClientRect();
          let aiPicImgOld = document.getElementById("aiPicImgOld");
          aiPicContentItem.style.width = aiPicImgNewRect.width + "px";
          aiPicContentItem.style.height = aiPicImgNewRect.height + "px";
          aiPicImgNew.style.width = aiPicImgNewRect.width + "px";
          aiPicImgNew.style.height = aiPicImgNewRect.height + "px";
          aiPicImgOld.style.width = aiPicImgNewRect.width + "px";
          aiPicImgOld.style.height = aiPicImgNewRect.height + "px";
        }
        if (this.aiPicInfo.url) {
          aiPicContentItem.style.cursor = "e-resize";
          aiPicContentItem.style.position = "relative";
          this.aiPicMouseMove();
        } else {
          aiPicContentItem.style.cursor = "default";
          let aiPicSlider = document.getElementById("aiPicSlider");
          aiPicSlider.style.display = "none";
          let aiPicImgNew = document.getElementById("aiPicImgNew");
          aiPicImgNew.style.clipPath = "rect(auto auto auto 0px)";
        }

        this.aiPicLoadingHide();

        this.$nextTick(() => {
          let aiPicContentItem = document.getElementById("aiPicContentItem");
          let aiPicImgOldImg =
            document.getElementById("aiPicImgOld").children[0];
          if (
            aiPicImgOldImg.naturalWidth <
              parseInt(aiPicContentItem.style.width) &&
            aiPicImgOldImg.naturalHeight <
              parseInt(aiPicContentItem.style.height)
          ) {
            aiPicImgOldImg.className = "lifeAlbum_pic_ai_edit_img_comfirm";
          } else {
            aiPicImgOldImg.className = "";
          }
          let aiPicImgNewImg =
            document.getElementById("aiPicImgNew").children[0];
          if (
            aiPicImgNewImg.naturalWidth <
              parseInt(aiPicContentItem.style.width) &&
            aiPicImgNewImg.naturalHeight <
              parseInt(aiPicContentItem.style.height)
          ) {
            aiPicImgNewImg.className = "lifeAlbum_pic_ai_edit_img_comfirm";
          } else {
            aiPicImgNewImg.className = "";
          }
        });
      }
    },
    aiPicLoadingHide() {
      this.aiPicLoadingShow = false;
      this.aiPicItemLoadingShow = false;
    },
    //照片优化查看-优化前和优化后
    aiPicMouseMove(event) {
      let aiPicContent = document.getElementById("aiPicContent");
      let aiPicContentRect = aiPicContent.getBoundingClientRect();
      let aiPicImgNew = document.getElementById("aiPicImgNew");
      let aiPicImgNewRect = aiPicImgNew.getBoundingClientRect();
      let aiPicSlider = document.getElementById("aiPicSlider");
      let x = 0;
      if (event) {
        x = event.clientX - aiPicImgNewRect.left;
      } else {
        x = aiPicImgNewRect.width / 2;
        aiPicSlider.style.display = "flex";
        aiPicSlider.style.height = aiPicImgNewRect.height + "px";
      }
      if (aiPicSlider.style.display != "none") {
        aiPicImgNew.style.clipPath = "rect(auto auto auto " + x + "px)";
        if (!event || (x > 0 && x < aiPicImgNewRect.width - 1)) {
          aiPicSlider.style.left = x - 20 + "px";
        }
      }
    },
    aiPicMouseLeave(event) {
      let aiPicImgNew = document.getElementById("aiPicImgNew");
      let aiPicImgNewRect = aiPicImgNew.getBoundingClientRect();
      let x = event.clientX - aiPicImgNewRect.left;
      if (x < 0) {
        x = 0;
      } else if (x > aiPicImgNewRect.width - 1) {
        x = aiPicImgNewRect.width - 1;
      }
      let aiPicSlider = document.getElementById("aiPicSlider");
      if (aiPicSlider.style.display != "none") {
        aiPicImgNew.style.clipPath = "rect(auto auto auto " + x + "px)";
        aiPicSlider.style.left = x - 20 + "px";
      }
    },
    aiPicAngleLoad() {
      this.aiPicLoadingHide();
    },
    //照片优化查看-1裁剪、2调整角度
    aiPicCropperClick(type) {
      this.initOSSsignature();
      this.aiPicLoadingShow = true;
      this.aiPicCropperShow = true;
      //显示角度调整
      //let aiPicContent = document.getElementById("aiPicContent");
      //let aiPicContentRect = aiPicContent.getBoundingClientRect();
      let aiPicContentItem = document.getElementById("aiPicContentItem");
      //let aiPicContentItemRect = aiPicContentItem.getBoundingClientRect();
      //显示裁剪区局
      //let aiPicCropperWidth = aiPicContentItemRect.width;
      //let aiPicCropperHeight = aiPicContentItemRect.height;
      let aiPicCropperWidth = "1100";
      let aiPicCropperHeight = "700";
      let aiPicCropper = document.getElementById("aiPicCropper");
      aiPicCropper.style.width = aiPicCropperWidth + "px";
      aiPicCropper.style.height = aiPicCropperHeight + "px";
      aiPicCropper.style.display = "block";
      //设置角度初始宽度
      let aiPicAngle = document.getElementById("aiPicAngle");
      aiPicAngle.style.width = aiPicCropperWidth + "px";
      //设置角度初始位置
      let aiPicAngleItem = document.getElementById("aiPicAngleItem");
      //let aiPicAngleItemRect = aiPicAngleItem.getBoundingClientRect();
      //let aiPicAngleItemRectWidth = aiPicAngleItemRect.width;
      let aiPicAngleItemRectWidth = 324;
      aiPicAngleItem.style.left =
        (aiPicCropperWidth - aiPicAngleItemRectWidth) / 2 + 1 + "px";
      aiPicAngleItem.setAttribute("left", aiPicAngleItem.style.left);
      //隐藏查看区域
      aiPicContentItem.style.display = "none";
      //裁剪数据加载
      if (type == 1) {
        this.aiPicAngleShow = false;
        this.getUrlDataSource(this.aiPicInfo.aiUrl).then((blob) => {
          this.cropperOption.imgUrl = this.aiPicInfo.aiUrl;
          this.cropperOption.img = URL.createObjectURL(blob);
          this.cropperOption.fixedBox = false;
          this.cropperOption.canMoveBox = true;
          this.cropperOption.autoCrop = true;
          this.cropperOption.rotateAngle = 0;
          this.cropperOption.imgLoad = this.aiPicCropperImgLoad;
        });
      } else if (type == 2) {
        this.aiPicAngleShow = true;
        this.getUrlDataSource(this.aiPicInfo.aiUrl).then((blob) => {
          this.aiPicAngleUrl = URL.createObjectURL(blob);
        });
      }
    },
    aiPicCropperImgLoad() {
      //设置裁剪框大小
      const vueCropperAngle = this.$refs.aiPicCropperRef.getRef();
      this.cropperOption.autoCropWidth =
        vueCropperAngle.trueWidth * vueCropperAngle.scale;
      this.cropperOption.autoCropHeight =
        vueCropperAngle.trueHeight * vueCropperAngle.scale;
      this.aiPicLoadingHide();
    },
    //照片优化查看-裁剪-返回
    aiPicCropperReturnClick() {
      let aiPicCropper = document.getElementById("aiPicCropper");
      aiPicCropper.style.display = "none";
      let aiPicContentItem = document.getElementById("aiPicContentItem");
      aiPicContentItem.style.display = "block";
      let aiPicAngle = document.getElementById("aiPicAngleImg");
      aiPicAngle.style.transform = "rotateZ(0deg)";
      this.aiPicLoad();
      this.aiPicAngleNum = 0;
      this.aiPicAngleNum90 = 0;
      this.aiPicCropperShow = false;
      this.aiPicAngleShow = false;
      this.cropperOption.img = "";
    },
    //照片优化查看-裁剪-重置
    aiPicCropperResetClick() {
      //设置角度初始位置
      let aiPicAngleItem = document.getElementById("aiPicAngleItem");
      aiPicAngleItem.style.left = aiPicAngleItem.getAttribute("left");
      this.$refs.aiPicCropperRef.refresh();
      this.aiPicAngleNum = 0;
      this.aiPicAngleNum90 = 0;
      this.cropperOption.autoCrop = true;
    },
    //照片优化查看-调整角度
    aiPicAngleMouseDown(event) {
      this.aiPicAngleLeft = null;
      //this.$refs.aiPicCropperRef.rotateStart();
      window.addEventListener("mouseup", this.aiPicAngleMouseUp);
      window.addEventListener("mousemove", this.aiPicAngleMouseMove);
    },
    aiPicAngleMouseUp(event) {
      //this.$refs.aiPicCropperRef.rotateEnd();
      window.removeEventListener("mouseup", this.aiPicAngleMouseUp);
      window.removeEventListener("mousemove", this.aiPicAngleMouseMove);
    },
    aiPicAngleMouseMove(event) {
      if (this.aiPicAngleLeft != null) {
        let aiPicAngle = document.getElementById("aiPicAngle");
        let aiPicAngleRect = aiPicAngle.getBoundingClientRect();
        let aiPicAngleItem = document.getElementById("aiPicAngleItem");
        let aiPicAngleItemRect = aiPicAngleItem.getBoundingClientRect();
        let num =
          parseInt(aiPicAngleItem.style.left) -
          (this.aiPicAngleLeft - event.clientX);
        if (
          num > -(aiPicAngleItemRect.width - aiPicAngleRect.width / 2 - 7) &&
          num < aiPicAngleRect.width / 2 - 4
        ) {
          aiPicAngleItem.style.left = num + "px";
          this.aiPicAngleNum =
            this.aiPicAngleNum + (this.aiPicAngleLeft - event.clientX);
          //this.$refs.aiPicCropperRef.rotate(this.aiPicAngleNum / 3.46);
          let aiPicAngle = document.getElementById("aiPicAngleImg");
          aiPicAngle.style.transform =
            "rotateZ(" +
            (parseInt(this.aiPicAngleNum / 3.46) + this.aiPicAngleNum90) +
            "deg)";
        }
      }
      this.aiPicAngleLeft = event.clientX;
    },
    aiPicAngleRotateLeft() {
      this.aiPicAngleNum90 = this.aiPicAngleNum90 - 90;
      let aiPicAngle = document.getElementById("aiPicAngleImg");
      aiPicAngle.style.transform =
        "rotateZ(" +
        (parseInt(this.aiPicAngleNum / 3.46) + this.aiPicAngleNum90) +
        "deg)";
      //this.aiPicAngleRotate90(-90);
      //this.$refs.aiPicCropperRef.rotateLeft();
    },
    aiPicAngleRotateRight() {
      this.aiPicAngleNum90 = this.aiPicAngleNum90 + 90;
      let aiPicAngle = document.getElementById("aiPicAngleImg");
      aiPicAngle.style.transform =
        "rotateZ(" +
        (parseInt(this.aiPicAngleNum / 3.46) + this.aiPicAngleNum90) +
        "deg)";
      //this.aiPicAngleRotate90(90);
      //this.$refs.aiPicCropperRef.rotateRight();
    },
    aiPicAngleRotate90(angle) {
      this.aiPicItemLoadingShow = true;
      let canvas = document.createElement("canvas");
      let ctx = canvas.getContext("2d");
      let img = new Image();
      img.src = this.aiPicAngleUrl;
      img.onload = () => {
        // 设置 canvas 的尺寸为旋转后的尺寸
        canvas.width = img.height; // 旋转后宽度变为原高度
        canvas.height = img.width; // 旋转后高度变为原宽度
        // 旋转图片 90 度
        ctx.translate(canvas.width / 2, canvas.height / 2); // 将原点移动到画布中心
        ctx.rotate((angle * Math.PI) / 180); // 旋转 90 度
        ctx.drawImage(img, -img.width / 2, -img.height / 2); // 绘制图片
        ctx.restore();
        canvas.toBlob((blob) => {
          this.aiPicAngleUrl = URL.createObjectURL(blob);
          this.aiPicItemLoadingShow = false;
        }, "image/png");
      };
    },
    aiPicAngleRotateAny() {
      return new Promise((resolve, reject) => {
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d");
        let img = new Image();
        img.src = this.aiPicAngleUrl;
        img.onload = () => {
          // 设置 canvas 的大小以适应旋转后的图片
          let radians =
            ((parseInt(this.aiPicAngleNum / 3.46) + this.aiPicAngleNum90) *
              Math.PI) /
            180;
          let sin = Math.abs(Math.sin(radians));
          let cos = Math.abs(Math.cos(radians));
          let imgW = img.width;
          let imgH = img.height;
          canvas.width = imgW * cos + imgH * sin;
          canvas.height = imgW * sin + imgH * cos;
          // 旋转图片
          ctx.translate(canvas.width / 2, canvas.height / 2);
          ctx.rotate(radians);
          ctx.drawImage(img, -imgW / 2, -imgH / 2, imgW, imgH);
          ctx.restore();
          //判断图片最大值
          let maxWidth = 1920;
          let maxHeight = 1080;
          if (canvas.width > maxWidth || canvas.height > maxHeight) {
            let canvasResize = document.createElement("canvas");
            let ctxResize = canvasResize.getContext("2d");
            // 计算 Canvas 的实际尺寸
            let aspectRatio = canvas.width / canvas.height;
            let canvasWidth = maxWidth;
            let canvasHeight = maxWidth / aspectRatio;
            if (canvasHeight > maxHeight) {
              canvasHeight = maxHeight;
              canvasWidth = maxHeight * aspectRatio;
            }
            canvasResize.width = canvasWidth;
            canvasResize.height = canvasHeight;
            ctxResize.drawImage(
              canvas,
              0,
              0,
              canvas.width,
              canvas.height, // 原始 Canvas 的区域
              0,
              0,
              canvasWidth,
              canvasHeight // 目标 Canvas 的区域
            );
            ctxResize.restore();
            canvas = canvasResize;
          }
          canvas.toBlob((blob) => {
            let newFile = blob; //URL.createObjectURL(blob);
            let nameArray = this.aiPicInfo.aiUrl
              .substring(this.aiPicInfo.aiUrl.lastIndexOf("/") + 1)
              .split(".");
            newFile.name = nameArray[0] + "_cut." + nameArray[1];
            resolve(newFile);
          }, "image/png");
        };
      });
    },
    //照片优化查看-全部重置
    aiPicResetClick() {
      if (this.aiPicInfo.aiUrlOriginal != this.aiPicInfo.aiUrl) {
        this.aiPicInfo.url = this.aiPicInfo.urlOriginal;
        this.aiPicInfo.aiUrl = this.aiPicInfo.aiUrlOriginal;
        this.aiPicInfo.urlKey = new Date().getTime();
        this.aiPicInfo.aiUrlKey = new Date().getTime() + 1;
        this.aiPicLoadCount = 0;
        this.aiPicLoadingShow = true;
      }
    },
    //照片优化查看-确认
    async aiPicEditConfirm() {
      if (this.aiPicCropperShow) {
        this.aiPicLoadingShow = true;
        this.aiPicLoadCount = 0;
        if (this.initOSSsignature(this.aiPicEditConfirm)) {
          let file;
          if (this.aiPicAngleShow) {
            file = await this.aiPicAngleRotateAny();
          } else {
            file = await this.$refs.aiPicCropperRef.getCropperFile();
          }
          this.multipartUpload(
            file,
            this.uploadAiPicCropperProgress,
            this.uploadAiPicCropperFinish
          );
        }
      } else {
        if (this.aiPicInfo.aiUrlOriginal == this.aiPicInfo.aiUrl) {
          this.replacePhotoAiUrlHide();
        } else {
          let params = {
            id: this.aiPicInfo.id,
            photoUrl: this.aiPicInfo.aiUrlOriginal,
            aiUrl: this.aiPicInfo.aiUrl,
            size: this.aiPicInfo.size,
          };
          this.confirmLifeAlbumPhotoAiUrl(params).then((res) => {
            if (res.status == 1000) {
              this.picList[this.aiPicInfo.index].photoUrlSource =
                this.aiPicInfo.aiUrlOriginal;
              this.picList[this.aiPicInfo.index].photoUrl =
                this.aiPicInfo.aiUrl;
              this.picList[this.aiPicInfo.index].aiUrl = this.aiPicInfo.aiUrl;
              this.replacePhotoAiUrlHide();
              this.$message.success("操作成功");
            }
          });
        }
      }
    },
    uploadAiPicCropperProgress(picEditIndex, progress) {},
    uploadAiPicCropperFinish(picEditIndex, photoUrl, size) {
      //console.log(photoUrl);
      //this.aiPicLoadingShow = false;
      this.aiPicInfo.url = this.aiPicInfo.aiUrl;
      this.aiPicInfo.aiUrl = photoUrl;
      this.aiPicInfo.size = size;
      this.aiPicCropperReturnClick();
    },
    //替换照片-AI
    replacePhotoAiUrlShow(item, i) {
      if (this.choicePicType != 0) {
        return;
      }
      if (!this.validateState(undefined, i)) {
        return;
      }
      this.aiPicInfo = {
        show: true,
        index: i,
        id: item.id,
        radio: -1,
        url: item.aiUrl ? item.photoUrlSource : "",
        aiUrl: item.aiUrl ? item.aiUrl : item.photoUrlSource,
      };
      this.aiPicInfo.urlOriginal = this.aiPicInfo.url;
      this.aiPicInfo.aiUrlOriginal = this.aiPicInfo.aiUrl;
      this.photoAlbumDetails = {
        aiShow: true,
      };
      this.aiPicAngleNum = 0;
      this.aiPicAngleNum90 = 0;
      this.aiPicCropperShow = false;
      this.aiPicLoadCount = 0;
      this.aiPicLoadingShow = true;
      if (this.aiPicInfo.index < this.picList.length - 1) {
        this.aiPicItemNextShow = true;
      } else {
        this.aiPicItemNextShow = false;
      }
      if (this.aiPicInfo.index > 0) {
        this.aiPicItemPrevShow = true;
      } else {
        this.aiPicItemPrevShow = false;
      }
    },
    replacePhotoAiUrlPrev() {
      let index = this.aiPicInfo.index - 1;
      this.replacePhotoAiUrlHide();
      this.$nextTick(() => {
        this.replacePhotoAiUrlShow(this.picList[index], index);
      });
    },
    replacePhotoAiUrlNext() {
      let index = this.aiPicInfo.index + 1;
      this.replacePhotoAiUrlHide();
      this.$nextTick(() => {
        this.replacePhotoAiUrlShow(this.picList[index], index);
      });
    },
    replacePhotoAiUrlHide() {
      this.aiPicInfo = {
        show: false,
        index: -1,
        id: -1,
        radio: -1,
        url: "",
        aiUrl: "",
      };
      this.photoAlbumDetails = {
        aiShow: false,
      };
      this.cropperOption.img = "";
    },
    replacePhotoAiUrlCheck(radio) {
      this.aiPicInfo.radio = radio;
    },
    replacePhotoAiUrl() {
      if (this.aiPicInfo.radio != 1 && this.aiPicInfo.radio != 2) {
        this.$message.error("请选择照片");
        return;
      }
      let params = {
        id: this.aiPicInfo.id,
        state: this.aiPicInfo.radio,
      };
      this.replaceLifeAlbumPhotoAiUrl(params).then((res) => {
        if (res.status == 1000) {
          if (this.aiPicInfo.radio == 1 || this.aiPicInfo.radio == 2) {
            if (this.aiPicInfo.radio == 2) {
              this.picList[this.aiPicInfo.index].photoUrl =
                this.aiPicInfo.aiUrl;
            }
            this.picList[this.aiPicInfo.index].aiUrl = "";
            this.$set(
              this.picList,
              this.aiPicInfo.index,
              this.picList[this.aiPicInfo.index]
            );
          }
          this.setExistPhotoAi(this.picList);
          this.replacePhotoAiUrlHide();
          this.$message.success("操作成功");
        }
      });
    },
    replacePhotoAiUrlAll() {
      this.$confirm("确认全部替换照片吗？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.replaceLifeAlbumPhotoAiUrlAll(this.dmId).then((res) => {
            if (res.status == 1000) {
              this.picList.some((item) => {
                if (item.aiUrl) {
                  item.photoUrl = item.aiUrl;
                  item.aiUrl = "";
                }
              });
              this.setExistPhotoAi(this.picList);
              this.$message.success("操作成功");
            }
          });
        })
        .catch(() => {});
    },
    setExistPhotoAi(list) {
      this.existPhotoAi = false;
      this.showPhotoAiAllButton = false;
      list.some((item) => {
        if (item.aiUrl) {
          this.existPhotoAi = true;
        }
        if (!item.aiUrlCount) {
          this.showPhotoAiAllButton = true;
        }
      });
    },
    //下载照片-AI
    downloadPhotoAi(url) {
      if (url) {
        axios({
          method: "POST",
          url: "/api/common/getUrlDataSource",
          data: {
            data: url,
          },
          responseType: "blob",
        }).then((response) => {
          let a = document.createElement("a");
          a.href = URL.createObjectURL(response.data);
          let name = "";
          if (this.SpaceManagement.spaceDetails.details.name.length > 6) {
            name = this.SpaceManagement.spaceDetails.details.name.substring(
              0,
              6
            );
          } else {
            name = this.SpaceManagement.spaceDetails.details.name;
          }
          a.download =
            "相册-照片" +
            (this.aiPicInfo.index + 1) +
            "-" +
            name +
            nowDate.getNowDate() +
            url.substring(url.lastIndexOf("."));
          a.click();
          window.URL.revokeObjectURL(url);
        });
      }
    },
    //AI照片合成
    compositePhotoAiShow() {
      let dataList = [];
      this.picList.forEach((data) => {
        if (data.checked) {
          dataList.push(data.photoUrl);
        }
      });
      if (dataList.length > 0) {
        this.aiPicCompositeList = [];
        this.aiPicComposite = true;
        this.choicePhotoCancel();
        this.compositePhotoAiHeadPic(dataList, 0);
      } else {
        this.$message.error("请选择照片");
      }
    },
    compositePhotoAiHeadPic(dataList, index) {
      this.aiPicCompositeLoading = true;
      this.aiPicCompositeLoadingType = 1;
      this.compositeLifeAlbumPhotoAiHeadPic(dataList[index]).then((res) => {
        if (res.status == 1000) {
          res.data.forEach((photoBase64) => {
            this.aiPicCompositeList.push({
              photoBase64: photoBase64,
              checked: false,
            });
          });
          if (index < dataList.length - 1) {
            setTimeout(() => {
              this.compositePhotoAiHeadPic(dataList, index + 1);
            }, 1000);
            return;
          }
        }
        this.aiPicCompositeLoading = false;
        this.aiPicCompositeLoadingType = 0;
      });
    },
    clickChoiceCompositePhotoAi(index) {
      if (this.aiPicCompositeList[index].checked) {
        this.aiPicCompositeList[index].checked = false;
      } else {
        this.aiPicCompositeList[index].checked = true;
      }
    },
    callPhotoAi(type) {
      //类型：1颜色增强，2着色、3消除折痕、4照片合成-模板、5照片合成-顺序、6照片合成
      if (type == 1 || type == 2 || type == 3) {
        this.aiPicItemLoadingShow = true;
        let params = {
          dmId: this.dmId,
          type: type,
          photoUrl: this.aiPicInfo.aiUrl,
        };
        this.callPhotoAiTimer(params);
      } else if (type == 4 || type == 5 || type == 6) {
        let dataList = [];
        this.aiPicCompositeList.forEach((data) => {
          if (data.checked) {
            dataList.push(data.photoBase64);
          }
        });
        if (dataList.length > 0) {
          this.aiPicCompositeLoading = true;
          this.aiPicCompositeLoadingType = 2;
          let params = {
            dmId: this.dmId,
            type: type,
            photoBase64List: dataList,
            photoUrl: this.aiPicCompositeTemplateUrl,
          };
          this.callPhotoAiTimer(params);
        } else {
          this.$message.error("请选择头像");
        }
      }
    },
    callPhotoAiTimer(params) {
      const type = params.type;
      this.callLifeAlbumPhotoAi(params).then((res) => {
        if (res.status == 1000) {
          if (res.data.aiUrl) {
            //console.log(res.data.size, res.data.aiUrl);
            if (type == 1 || type == 2 || type == 3) {
              this.aiPicInfo.url = this.aiPicInfo.aiUrl;
              this.aiPicInfo.aiUrl = res.data.aiUrl;
              this.aiPicInfo.size = res.data.size;
            } else if (type == 4) {
              this.aiPicCompositeTemplateUrl = res.data.aiUrl;
            } else if (type == 5) {
              this.aiPicCompositeTemplateList = JSON.parse(
                res.data.aiUrl
              ).seg_base64_images;
            } else if (type == 6) {
              this.aiPicCompositeUrl = res.data.aiUrl;
            }
            this.$message.success("操作成功");
          } else {
            params.listenerId = res.data.listenerId;
            setTimeout(() => {
              this.callPhotoAiTimer(params);
            }, 5000);
            return;
          }
        }
        if (type == 1 || type == 2 || type == 3) {
          this.aiPicItemLoadingShow = false;
        } else if (type == 4 || type == 5 || type == 6) {
          this.aiPicCompositeLoading = false;
          this.aiPicCompositeLoadingType = 0;
        }
      });
    },
    //添加人生相册模板
    addLifeAlbumTemplate() {
      if (!this.validateState()) {
        return;
      }
      if (this.picList.length < 2) {
        this.$message.error("少于2张照片，请上传照片");
        return;
      }
      this.lifeAlbumStepClick(2);
    },
    //开头和结尾改变事件
    beginEndStateChange() {
      if (this.dataInfo.beginEndState == 0) {
        this.templateSubtitleRequired = false;
        this.templateSubtitleDisabled = true;
        let dataInfoClone = { ...this.dataInfo };
        dataInfoClone.subtitle1Code = "";
        dataInfoClone.subtitle2Code = "";
        dataInfoClone.subtitle3Code = "";
        this.dataInfo = dataInfoClone;
      } else if (this.dataInfo.beginEndState == 1) {
        this.templateSubtitleRequired = true;
        this.templateSubtitleDisabled = false;
      }
      this.templateSubtitleShow = false;
      this.$nextTick(() => {
        this.templateSubtitleShow = true;
      });
    },
    //字幕改变事件
    templateSubtitle1Change(value) {
      this.templateSubtitleRequired = true;
      if (value == "-1") {
        this.dataInfo.subtitle2Code = "-1";
        this.dataInfo.subtitle3Code = "-1";
      }
    },
    templateSubtitleChange(value) {
      this.templateSubtitleRequired = true;
    },
    //查看人生相册模板
    viewLifeAlbumTemplateShow(type) {
      if (
        this.templateSubtitleDisabled &&
        (type == 3 || type == 4 || type == 5)
      ) {
        return;
      }
      switch (type) {
        case 1:
          this.templateViewTitle = "背景库";
          this.templateViewList = this.templateBgList;
          this.templateViewRadio = this.dataInfo.bgCode;
          break;
        case 2:
          this.templateViewTitle = "音乐库";
          this.templateViewList = this.templateMusicList;
          this.templateViewRadio = this.dataInfo.musicCode;
          break;
        case 3:
          this.templateViewTitle = "人生角色库";
          this.templateViewList = this.templateSubtitle1List;
          this.templateViewRadio = this.dataInfo.subtitle1Code;
          break;
        case 4:
          this.templateViewTitle = "人才类型库";
          this.templateViewList = this.templateSubtitle2List;
          this.templateViewRadio = this.dataInfo.subtitle2Code;
          break;
        case 5:
          this.templateViewTitle = "天命库";
          this.templateViewList = this.templateSubtitle3List;
          this.templateViewRadio = this.dataInfo.subtitle3Code;
          break;
      }
      this.templateViewType = type;
      this.templateViewShow = true;
      this.photoAlbumDetails = {
        aiShow: true,
      };
    },
    viewLifeAlbumTemplateClose() {
      this.templateViewShow = false;
      this.templateViewTitle = "";
      this.templateViewList = [];
      this.templateViewType = 0;
      this.templateViewRadio = "";
      this.photoAlbumDetails = {
        aiShow: false,
      };
    },
    clickTemplateViewButton() {
      if (this.templateViewRadio == "") {
        this.$message.error(
          "请选择" +
            this.templateViewTitle.substring(
              0,
              this.templateViewTitle.length - 1
            )
        );
        return;
      }
      let dataInfoClone = { ...this.dataInfo };
      switch (this.templateViewType) {
        case 1:
          dataInfoClone.bgCode = this.templateViewRadio;
          break;
        case 2:
          dataInfoClone.musicCode = this.templateViewRadio;
          break;
        case 3:
          dataInfoClone.subtitle1Code = this.templateViewRadio;
          if (dataInfoClone.subtitle1Code == "-1") {
            dataInfoClone.subtitle2Code = "-1";
            dataInfoClone.subtitle3Code = "-1";
          }
          break;
        case 4:
          dataInfoClone.subtitle2Code = this.templateViewRadio;
          break;
        case 5:
          dataInfoClone.subtitle3Code = this.templateViewRadio;
          break;
      }
      this.dataInfo = dataInfoClone;
      this.viewLifeAlbumTemplateClose();
    },
    clickTemplateViewRadio(code) {
      this.templateViewRadio = code;
    },
    playLifeAlbumTemplateMusic(isPlay, index) {
      if (isPlay) {
        this.templateViewList[index].isPlay = false;
        this.$set(this.templateViewList, index, this.templateViewList[index]);
        document.getElementById("lifeAlbumTemplateMusicAudio").pause();
      } else {
        if (index != undefined) {
          this.templateViewList.forEach((item) => {
            if (item.isPlay) {
              item.isPlay = false;
            }
          });
          this.templateViewList[index].isPlay = true;
          this.$set(this.templateViewList, index, this.templateViewList[index]);
          document.getElementById("lifeAlbumTemplateMusicAudio").src =
            this.templateViewList[index].remark;
          document.getElementById("lifeAlbumTemplateMusicAudio").load();
        }
        try {
          document.getElementById("lifeAlbumTemplateMusicAudio").play();
        } catch (e) {
          setTimeout(() => {
            this.playLifeAlbumTemplateMusic(isPlay);
          }, 500);
        }
      }
    },
    //添加人生相册
    createLifeAlbum() {
      this.$refs["dataInfoRef"].validate((validate) => {
        if (validate) {
          if (this.dataInfo.beginEndState == 1) {
            let subtitleNochoose = false;
            let subtitleNochooseCount = 0;
            if (this.dataInfo.subtitle1Code == "-1") {
              subtitleNochoose = true;
              subtitleNochooseCount++;
            }
            if (this.dataInfo.subtitle2Code == "-1") {
              subtitleNochoose = true;
              subtitleNochooseCount++;
            }
            if (this.dataInfo.subtitle3Code == "-1") {
              subtitleNochoose = true;
              subtitleNochooseCount++;
            }
            if (subtitleNochoose && subtitleNochooseCount < 3) {
              this.$message.error("可选项选择不匹配，请重新选择");
              return false;
            }
          }
          this.addLifeAlbum();
        } else {
          return false;
        }
      });
    },
    addLifeAlbum() {
      this.videoShow = false;
      this.videoProcess = 1;
      this.videoProcessText = "";
      this.videoProcessButton = 0;
      this.createVideoType = 1;
      this.downloadVideoUrl = "";
      this.dataInfo.videoUrl = "";
      this.dataInfo.dmId = this.dmId;
      this.lifeAlbumStepClick(3);
      this.$nextTick(() => {
        document.getElementById("scrollDiv").scrollTop = 9999;
      });
      axios({
        method: "POST",
        url: localUrl() + "bygLifeAlbum/addByDmId",
        data: {
          data: this.dataInfo,
        },
        responseType: "json",
      })
        .then((res) => {
          res = res.data;
          if (res.status == 1000) {
            this.videoListener = true;
            this.listenerAddLifeAlbum(res.data, 1, "", true);
          } else {
            this.lifeAlbumStepClick(2);
            if (res.status == 1001) {
              this.$message.error("获取信息失败，请检查网络连接");
            } else {
              this.$message.error(res.message);
            }
          }
        })
        .catch((err) => {
          this.videoProcessButton = this.createVideoType;
          this.videoProcessText = "获取信息失败，请检查本地服务是否启动";
          // this.addLifeAlbumByDmId(this.dataInfo).then((res) => {
          //   if (res.status == 1000) {
          //     this.videoListener = true;
          //     this.listenerAddLifeAlbum(res.data, 1);
          //   } else {
          //     this.lifeAlbumStepClick(2);
          //   }
          // });
        });
    },
    //添加人生相册-监听是否完成
    listenerAddLifeAlbum(listenerId, type, fileName = "", isLocal) {
      let params = {
        dmId: this.dmId,
        listenerId: listenerId,
        listenerType: type,
        fileName: fileName,
        sessionID: this.dataInfo.sessionID,
      };
      if (isLocal) {
        axios({
          method: "POST",
          url: localUrl() + "bygLifeAlbum/addListener",
          data: {
            data: params,
          },
          responseType: "json",
        })
          .then((res) => {
            this.listenerAddLifeAlbumCallback(
              res.data,
              listenerId,
              type,
              fileName,
              isLocal
            );
          })
          .catch((err) => {
            this.videoProcessButton = type;
            this.videoProcessText = "获取信息失败，请检查本地服务是否启动";
          });
      } else {
        this.videoProcessButton = type;
        this.videoProcessText = "获取信息失败，请检查本地服务是否启动";
        // this.addLifeAlbumListener(params).then((res) => {
        //   this.listenerAddLifeAlbumCallback(
        //     res,
        //     listenerId,
        //     type,
        //     fileName,
        //     isLocal
        //   );
        // });
      }
    },
    listenerAddLifeAlbumCallback(res, listenerId, type, fileName, isLocal) {
      if (res.status == 1000) {
        if (res.data.process > this.videoProcess && this.videoProcess < 99) {
          this.videoProcess = parseInt(res.data.process);
        }

        this.videoProcessText = res.data.processText;

        if (res.data.videoUrl) {
          this.videoProcess = 100;
          if (type == 1) {
            if (res.data.videoUrl.indexOf("http") == 0) {
              this.dataInfo.videoUrl = res.data.videoUrl;
            } else {
              this.dataInfo.videoUrl =
                localUrl() +
                "bygLifeAlbum/getUrlDataSource?fileName=" +
                encodeURIComponent(res.data.videoUrl);
            }
            this.dataInfo.videoSubtitleUrl = res.data.videoSubtitleUrl;
            setTimeout(() => {
              this.videoShow = true;
              this.videoReload(0);
            }, 1000);
          } else if (type == 2) {
            this.uploadVideoToDmPhoto(type, res.data.videoUrl, fileName);
          } else if (type == 3) {
            this.downloadLifeAlbumLog(type, res.data.videoUrl);
          }
        } else {
          if (this.videoListener) {
            setTimeout(() => {
              this.listenerAddLifeAlbum(listenerId, type, fileName, isLocal);
            }, 5000);
          }
        }
      } else {
        this.videoProcessButton = type;
        if (res.status == 1001) {
          this.videoProcessText = "获取信息失败，请检查网络连接！";
        } else {
          this.videoProcessText = res.message;
        }

        if (isLocal) {
          if (res.status == 1001) {
            this.$message.error("获取信息失败，请检查网络连接");
          } else {
            this.$message.error(res.message);
          }
        }
      }
    },
    videoReload(num) {
      try {
        document.querySelector("video").load();
      } catch (e) {
        if (num < 5) {
          setTimeout(() => {
            this.videoReload(++num);
          }, 1000);
        }
      }
    },
    clickVideoProcessButton() {
      if (this.videoProcessButton == 1) {
        this.lifeAlbumStepClick(2);
      } else {
        this.videoShow = true;
        this.videoProcess = 0;
      }
      this.videoProcessButton = 0;
    },
    //下载人生相册
    downloadLifeAlbum(type) {
      this.videoShow = false;
      this.videoProcess = 1;
      this.videoProcessText = "";
      this.videoProcessButton = 0;
      this.createVideoType = type;
      this.downloadVideoUrl = "";
      let name = "";
      let title = "";
      if (this.SpaceManagement.spaceDetails.details.name.length > 6) {
        name = this.SpaceManagement.spaceDetails.details.name.substring(0, 6);
      } else {
        name = this.SpaceManagement.spaceDetails.details.name;
      }
      if (type == 2) {
        if (this.dataInfo.beginEndState == 0) {
          title = "空白版";
        } else if (this.dataInfo.beginEndState == 1) {
          title = this.dataInfo.subtitle1Code != "-1" ? "标准版" : "首尾版";
        }
      } else if (type == 3) {
        if (this.dataInfo.beginEndState == 1) {
          title =
            this.dataInfo.subtitle1Code != "-1"
              ? "标准无旁白版"
              : "首尾无旁白版";
        }
      }
      name = "相册（" + title + "）-" + name;
      name += nowDate.getNowDate() + ".mp4";
      let params = {
        dmId: this.dmId,
        type: type,
        fileName: name,
        sessionID: this.dataInfo.sessionID,
      };

      axios({
        method: "POST",
        url: localUrl() + "bygLifeAlbum/downloadVideo",
        data: {
          data: params,
        },
        responseType: "json",
      })
        .then((res) => {
          res = res.data;
          if (res.status == 1000) {
            if (res.data.indexOf("http") == 0) {
              this.videoProcess = 100;
              if (type == 2) {
                this.uploadVideoToDmPhoto(type, res.data, name);
              } else if (type == 3) {
                this.downloadLifeAlbumLog(type, res.data);
              }
            } else {
              this.videoListener = true;
              this.listenerAddLifeAlbum(res.data, type, name, true);
            }
          } else {
            this.videoShow = true;
            this.videoProcess = 0;
            if (res.status == 1001) {
              this.$message.error("获取信息失败，请检查网络连接");
            } else {
              this.$message.error(res.message);
            }
          }
        })
        .catch((err) => {
          this.videoProcessButton = this.createVideoType;
          this.videoProcessText = "获取信息失败，请检查本地服务是否启动";
          // this.downloadLifeAlbumVideo(params).then((res) => {
          //   if (res.status == 1000) {
          //     if (res.data.indexOf("http") == 0) {
          //       this.videoProcess = 100;
          //       if (type == 2) {
          //         this.uploadVideoToDmPhoto(type, res.data, name);
          //       } else if (type == 3) {
          //         this.downloadLifeAlbumLog(type, res.data);
          //       }
          //     } else {
          //       this.videoListener = true;
          //       this.listenerAddLifeAlbum(res.data, type, name);
          //     }
          //   } else {
          //     this.videoShow = true;
          //     this.videoProcess = 0;
          //   }
          // });
        });
    },
    downloadLifeAlbumLog(type, url) {
      let params = {
        dmId: this.dmId,
      };
      if (type == 2) {
        params.type = "TYPE_LIFEALBUM_DOWNLOAD_VIDEO";
        if (this.dataInfo.beginEndState == 0) {
          params.type = "TYPE_LIFEALBUM_DOWNLOAD_VIDEO_V0";
        } else if (
          this.dataInfo.beginEndState == 1 &&
          this.dataInfo.subtitle1Code == "-1"
        ) {
          params.type = "TYPE_LIFEALBUM_DOWNLOAD_VIDEO_V2";
        }
      } else if (type == 3) {
        params.type = "TYPE_LIFEALBUM_DOWNLOAD_VIDEO_NO_NARRATION";
        if (
          this.dataInfo.beginEndState == 1 &&
          this.dataInfo.subtitle1Code == "-1"
        ) {
          params.type = "TYPE_LIFEALBUM_DOWNLOAD_VIDEO_NO_NARRATION_V2";
        }
      } else if (type == 4) {
        params.type = "TYPE_LIFEALBUM_DOWNLOAD_PHOTO";
      }
      this.saveLog(params).then((res) => {
        if (res.status == 1000) {
          if (url) {
            this.downloadVideoUrl =
              url.replace("http:", "https:") + "&" + new Date().getTime();
            let a = document.createElement("a");
            a.href = this.downloadVideoUrl;
            a.click();
            window.URL.revokeObjectURL(url);
            setTimeout(() => {
              this.videoShow = true;
            }, 2000);
          }
        } else {
          this.videoShow = true;
          this.videoProcess = 0;
        }
      });
    },
    //上传视频到纪念堂资料
    uploadVideoToDmPhoto(type, url, fileName) {
      let params = {
        dmId: this.dmId,
        fileName: fileName,
      };
      this.uploadLifeAlbumVideoToDmPhoto(params).then((res) => {
        if (res.status == 1000) {
          this.refreshDmPhoto();
          this.downloadLifeAlbumLog(type, url);
        } else {
          this.videoShow = true;
          this.videoProcess = 0;
        }
      });
    },
    //上传照片到纪念堂资料
    uploadPhotoToDmPhoto() {
      this.videoShow = false;
      this.videoProcess = 1;
      this.videoProcessText = "";
      this.videoProcessButton = 0;
      this.createVideoType = 4;
      this.downloadVideoUrl = "";
      let name = "";
      if (this.SpaceManagement.spaceDetails.details.name.length > 6) {
        name = this.SpaceManagement.spaceDetails.details.name.substring(0, 6);
      } else {
        name = this.SpaceManagement.spaceDetails.details.name;
      }
      name = "相册（照片）-" + name;
      name += nowDate.getNowDate() + ".zip";
      let params = {
        dmId: this.dmId,
        fileName: name,
      };
      this.uploadLifeAlbumPhotoToDmPhoto(params).then((res) => {
        if (res.status == 1000) {
          this.refreshDmPhoto();
          this.downloadLifeAlbumLog(4);
          this.downloadImagesAsZip(res.data, name);
        } else {
          this.videoShow = true;
          this.videoProcess = 0;
        }
      });
    },
    async downloadImagesAsZip(photoList, zipName) {
      let num = 0;
      const zip = new JSZip();
      const promises = photoList.map(async (data, index) => {
        const blob = await this.getUrlDataSource(data.photoUrl);
        if (blob) {
          zip.file(data.photoName, blob);
        }
        // 更新下载进度
        num++;
        this.videoProcess = parseInt((num / photoList.length) * 100);
        this.videoProcessText = `下载处理中，第${num}/${photoList.length}张`;
      });
      await Promise.all(promises);
      zip.generateAsync({ type: "blob" }).then((content) => {
        saveAs(content, zipName);
        // 下载完成
        this.downloadVideoUrl = zipName;
        setTimeout(() => {
          this.videoShow = true;
        }, 2000);
      });
    },
    //刷新纪念堂资料
    refreshDmPhoto() {
      this.findPhotoCategory(this.dmId);
      this.findByIdAnother(this.dmId).then((res) => {
        if (res.status == 1000) {
          if (res.data.fileVideoSizeUse == 0) {
            this.SpaceManagement.spaceDetails.details.fileVideoSizeUsef = 0;
          } else {
            this.SpaceManagement.spaceDetails.details.fileVideoSizeUsef =
              (res.data.fileVideoSizeUse / res.data.fileSizeCount) * 100;
            if (
              this.SpaceManagement.spaceDetails.details.fileVideoSizeUsef < 1
            ) {
              this.SpaceManagement.spaceDetails.details.fileVideoSizeUsef = 1;
            }
          }
          if (res.data.filePicSizeUse == 0) {
            this.SpaceManagement.spaceDetails.details.filePicSizeUsef = 0;
          } else {
            this.SpaceManagement.spaceDetails.details.filePicSizeUsef =
              (res.data.filePicSizeUse / res.data.fileSizeCount) * 100;
            if (this.SpaceManagement.spaceDetails.details.filePicSizeUsef < 1) {
              this.SpaceManagement.spaceDetails.details.filePicSizeUsef = 1;
            }
          }
          this.SpaceManagement.spaceDetails.details.fileSizeUse =
            res.data.fileSizeUse;
          this.SpaceManagement.spaceDetails.details.fileSizeCount =
            res.data.fileSizeCount;
          this.SpaceManagement.spaceDetails.details.fileSizeUseA =
            roundAll.roundFn(res.data.fileSizeUse / 1024 / 1024, 3);
          this.SpaceManagement.spaceDetails.details.fileSizeCountA =
            roundAll.roundFn(
              res.data.fileSizeCount / 1024 / 1024 -
                res.data.fileSizeUse / 1024 / 1024,
              3
            );

          this.SpaceManagement.spaceDetails.details.fileVideoCount =
            res.data.fileVideoCount;
          this.SpaceManagement.spaceDetails.details.filePicCount =
            res.data.filePicCount;
          this.SpaceManagement.spaceDetails.details.viewCount =
            res.data.viewCount;
        }
      });
    },
    //清除人生相册
    cleanLifeAlbum(type) {
      let title = "";
      let index = type;
      if (type == 3) {
        index = 2;
        title = "重选模板将覆盖当前视频，是否确认重选？";
      } else if (this.stepActive == 1) {
        //title = "回到上一步将需重新选择模板，是否确认回退？";
      } else if (this.stepActive == 2 || this.stepActive == 3) {
        title = "回到上一步将需重新生成人生相册视频，是否确认回退？";
      }
      if (title) {
        this.$confirm(title, "提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            this.lifeAlbumStepClick(index);
          })
          .catch(() => {});
      } else {
        this.lifeAlbumStepClick(index);
      }
      // let params = {
      //   dmId: this.dmId,
      //   type: index,
      // };
      // this.cleanLifeAlbumByDmId(params).then((res) => {
      //   if (res.status == 1000) {
      //     if (index == 1) {
      //       this.dataInfo = {};
      //       this.getPicList();
      //     } else if (index == 2) {
      //       this.dataInfo.videoUrl = "";
      //       this.getTemplateBgList();
      //       this.getTemplateMusicList();
      //       this.getTemplateSubtitle1List();
      //       this.getTemplateSubtitle2List();
      //       this.getTemplateSubtitle3List();
      //     }
      //     this.videoShow = false;
      //     this.stepActive = index - 1;
      //   }
      // });
    },
    //修改照片
    getPicEditList() {
      let params = {
        dmId: this.dmId,
        bgShow: 1,
      };
      this.findLifeAlbumPhotoAllByDmId(params).then((res) => {
        if (res.status == 1000) {
          this.picEditList = res.data;
        }
      });
    },
    editPhotoFrame(item, i) {
      if (item.progress >= 0 && item.progress <= 100) {
        return;
      }
      this.initOSSsignature();
      let that = this;
      this.cropperDialog = true;
      this.picEditIndex = i;
      this.cropperOption.photoFrameName = item.photoFrameName;
      this.findLifeAlbumPhotoFrameById(item.id).then((res) => {
        if (res.status == 1000) {
          res.data.forEach((data) => {
            if (data.photoFrameName == item.photoFrameName) {
              this.photoFrameSizeClick(data);
            }
          });
          this.photoFrameSizeArray = res.data;
        }
      });
      this.getUrlDataSource(
        item.photoUrl +
          "?x-oss-process=image/resize,m_fill,h_" +
          item.photoInFrameHeight +
          ",w_" +
          item.photoInFrameWidth
      ).then((blob) => {
        that.cropperOption.img = URL.createObjectURL(blob);
        that.cropperOption.imgUrl = item.photoUrl;
      });
    },
    photoFrameSizeClick(item) {
      this.cropperOption.fixedBox = true;
      this.cropperOption.canMoveBox = false;
      this.cropperOption.autoCrop = true;
      //this.cropperOption.rotateAngle = 0;
      //this.cropperOption.imgLoad = this.aiPicCropperImgLoad;
      this.cropperOption.photoFrameName = item.photoFrameName;
      this.cropperOption.autoCropWidth = item.photoInFrameWidth;
      this.cropperOption.autoCropHeight = item.photoInFrameHeight;
      this.picEditList[this.picEditIndex].photoFrameSize = item;
    },
    async editPhotoFrameConfirm(picEditIndex) {
      let file;
      if (picEditIndex == undefined) {
        file = await this.getCropperFile(this.$refs.cropper);
        this.picMap[file.uid] = this.picEditIndex;
        this.picEditList[this.picEditIndex].file = file;
        this.picEditList[this.picEditIndex].photoUrl =
          URL.createObjectURL(file);
        this.picEditList[this.picEditIndex].photoFrameName =
          this.picEditList[this.picEditIndex].photoFrameSize.photoFrameName;
        this.picEditList[this.picEditIndex].photoInFrameWidth =
          this.picEditList[this.picEditIndex].photoFrameSize.photoInFrameWidth;
        this.picEditList[this.picEditIndex].photoInFrameHeight =
          this.picEditList[this.picEditIndex].photoFrameSize.photoInFrameHeight;
        this.picEditList[this.picEditIndex].photoInFrameX =
          this.picEditList[this.picEditIndex].photoFrameSize.photoInFrameX;
        this.picEditList[this.picEditIndex].photoInFrameY =
          this.picEditList[this.picEditIndex].photoFrameSize.photoInFrameY;
        this.picEditList[this.picEditIndex].bgUrl =
          this.picEditList[this.picEditIndex].photoFrameSize.photoFrameUrl;
        this.picEditList[this.picEditIndex].progress = 0.01;
        this.editPhotoFrameCancel();
      } else {
        this.picEditList[picEditIndex].progress = 0.01;
        file = this.picEditList[picEditIndex].file;
      }

      this.multipartUpload(
        file,
        this.uploadCropperProgress,
        this.uploadCropperFinish
      );
    },
    uploadCropperProgress(picEditIndex, progress) {
      this.picEditList[picEditIndex].progress = progress;
    },
    uploadCropperFinish(picEditIndex, photoUrl) {
      this.picEditList[picEditIndex].photoUrl = photoUrl;
      this.editPicList(picEditIndex);
    },
    reuploadEditRequest(params, picEditIndex) {
      if (params.photoUrl.indexOf("https") == 0) {
        this.editPicList(picEditIndex);
      } else {
        this.editPhotoFrameConfirm(picEditIndex);
      }
    },
    //修改人生相册照片
    editPicList(picEditIndex) {
      let that = this;
      let data = {
        id: this.picEditList[picEditIndex].id,
        cropperUrlTemp: this.picEditList[picEditIndex].photoUrl,
        photoFrameName: this.picEditList[picEditIndex].photoFrameName,
        photoInFrameWidth:
          this.picEditList[picEditIndex].photoFrameSize.photoInFrameWidth,
        photoInFrameHeight:
          this.picEditList[picEditIndex].photoFrameSize.photoInFrameHeight,
        photoInFrameX:
          this.picEditList[picEditIndex].photoFrameSize.photoInFrameX,
        photoInFrameY:
          this.picEditList[picEditIndex].photoFrameSize.photoInFrameY,
      };
      this.editLifeAlbumPhotoCropperUrl(data).then((res) => {
        if (res.status == 1000) {
          that.picEditList[picEditIndex].progress = 100;
          that.$set(
            that.picEditList,
            picEditIndex,
            that.picEditList[picEditIndex]
          );
          setTimeout(() => {
            that.picEditList[picEditIndex].progress = 999;
            that.$set(
              that.picEditList,
              picEditIndex,
              that.picEditList[picEditIndex]
            );
          }, 500);
        } else {
          that.picEditList[picEditIndex].progress = 0;
          that.$set(
            that.picEditList,
            picEditIndex,
            that.picEditList[picEditIndex]
          );
        }
      });
    },
    editPhotoFrameCancel() {
      this.cropperDialog = false;
      this.cropperOption.img = "";
    },
    getUrlDataSource(url) {
      return new Promise((resolve, reject) => {
        axios({
          method: "POST",
          url: "/api/common/getUrlDataSource",
          data: {
            data: url,
          },
          responseType: "blob",
        })
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    async fetchUrlDataSource(url) {
      try {
        const response = await fetch(url, { mode: "cors" });
        if (!response.ok) throw new Error(`Failed to fetch image: ${url}`);
        return await response.blob();
      } catch (error) {
        console.error("Error fetching image:", error);
        return null;
      }
    },
    // 获取截图的blob数据
    async getCropperFile(cropper) {
      return new Promise((resolve, reject) => {
        cropper.getCropBlob((blob) => {
          let newFile = blob;
          let nameArray = this.cropperOption.imgUrl
            .substring(this.cropperOption.imgUrl.lastIndexOf("/") + 1)
            .split(".");
          newFile.name = nameArray[0] + "_cut." + nameArray[1];
          resolve(newFile);
        });
      });
    },
    //取消修改
    cancelPicEdit() {
      let title = "确认取消修改？";
      this.$confirm(title, "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.cancelLifeAlbumPhotoCropperUrl(this.dmId).then((res) => {
            if (res.status == 1000) {
              this.videoShow = true;
              this.lifeAlbumStepClick(3);
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="stylus" scoped>
video::cue {
  background: none;
  color: #fff;
  text-shadow: 0 1px #000, 1px 0 #000, -1px 0 #000, 0 -1px #000;
  font-size: 24px;
}

.lifeAlbum_page {
  .lifeAlbum_page_modal {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 1;
    background: #fff;
    z-index: 2000;
    display: flex;
    justify-content: center;
    align-items: center;

    div {
      width: 100%;
      height: 100%;
      opacity: 0.1;
      background-color: #000;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    img {
      width: 54px;
      height: 54px;
    }
  }

  user-select: none;

  .lifeAlbum_step_body {
    position: relative;

    .lifeAlbum_step_button {
      z-index: 2;
      position: absolute;
      width: 140px;
      height: 120px;
      margin: 18px;
    }

    .lifeAlbum_step_button1 {
      left: 512px;
    }

    .lifeAlbum_step_button2 {
      left: 812px;
    }

    .lifeAlbum_step_button3 {
      left: 1112px;
    }
  }

  .lifeAlbum_pic_body.noborder {
    border: 0;
  }

  .lifeAlbum_pic_body {
    width: 1740px;
    margin-left: 30px;
    background: #FFFFFF;
    border: 1px solid #CCD7EA;
    position: relative;
    display: flex;
    flex-direction: column;

    .lifeAlbum_pic_bar {
      width: 100%;
      height: 70px;

      .lifeAlbum_pic_bar_title {
        float: left;
        margin-left: 20px;
        width: 200px;
        line-height: 70px;

        a {
          color: #2c90ff;
        }
      }

      .lifeAlbum_pic_bar_buttons {
        float: right;
        margin-right: 110px;
        line-height: 70px;

        .upLoad_button {
          display: inline-block;
        }
      }
    }

    .lifeAlbum_pic_content {
      min-height: 400px;
      margin: 0 80px 0 20px;

      .lifeAlbum_pic_empty {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 400px;
        margin-bottom: 100px;

        .lifeAlbum_pic_empty_border {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          width: 400px;
          height: 170px;
          border: 0.1rem dashed #d9d9d9;
          border-radius: 0.2rem;
          cursor: pointer;

          img {
            width: 100px;
            height: 100px;
          }

          span {
            color: #3a81ff;
          }
        }
      }

      .lifeAlbum_pic_list {
        .lifeAlbum_pic_list_draggable {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          align-content: flex-start;
          width: 100%;
        }

        .lifeAlbum_pic_list_item {
          margin: 0 20px 10px 0;
          text-align: center;
          position: relative;

          .lifeAlbum_pic_list_item_content {
            width: 116px;
            height: 116px;
            position: relative;
            border-radius: 5px;
            overflow: hidden;

            img {
              width: 116px;
              height: 116px;
              overflow: hidden;
              object-fit: cover;
            }

            .lifeAlbum_pic_list_item_img_process {
              -webkit-filter: blur(0.1rem);
            }

            .lifeAlbum_pic_list_item_process {
              position: absolute;
              left: 0;
              right: 0;
              top: 0;
              bottom: 0;
              width: 116px;
              height: 116px;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              background: rgba(0, 0, 0, 0.4);

              .lifeAlbum_pic_list_item_process_success {
                width: 30px;
                height: 30px;
              }

              .lifeAlbum_pic_list_item_process_failed {
                z-index: 1;
                width: 56px;
                height: 63px;
                cursor: pointer;
              }

              .lifeAlbum_pic_list_item_process_bar {
                position: absolute;
                left: 10px;
                bottom: 10px;
                width: 100px;
              }

              .lifeAlbum_pic_list_item_process_loading {
                width: 30px;
                height: 30px;
              }
            }

            .lifeAlbum_pic_list_item_choice_ai {
              position: absolute;
              top: 0;
              left: 0;
              width: 116px;
              height: 116px;
            }

            .lifeAlbum_pic_list_item_choice {
              position: absolute;
              top: 5px;
              right: 5px;
              width: 24px;
              height: 24px;
            }

            .lifeAlbum_pic_list_item_choice_red_dot {
              position: absolute;
              top: -2px;
              right: -4px;
              width: 24px;
              height: 24px;
            }

            .lifeAlbum_pic_list_item_type_ai {
              position: absolute;
              top: 0;
              right: 0;
              width: 60px;
              height: 56px;
            }
          }

          .lifeAlbum_pic_list_item_index {
          }

          .lifeAlbum_pic_list_item_three_dot {
            position: absolute;
            bottom: 6px;
            right: 0;
            width: 3px;
            height: 13px;
            padding-right: 4px;
            padding-left: 10px;
            cursor: pointer;
          }

          .lifeAlbum_pic_list_item_options {
            position: absolute;
            right: 14px;
            bottom: -47px;
            width: 80px;
            height: 80px;
            background: #FFFFFF;
            box-shadow: 0px 0px 8px 2px rgba(222, 222, 222, 0.5);
            border-radius: 5px;
            z-index: 1;

            .lifeAlbum_pic_list_item_options_float_all {
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              height: 40px;
              cursor: pointer;

              .lifeAlbum_pic_list_item_options_float_icon {
                width: 16px;
                height: 16px;
                margin-right: 8px;
              }

              .lifeAlbum_pic_list_item_options_float_black {
                font-size: 14px;
                font-weight: 400;
                color: #000000;
              }

              .lifeAlbum_pic_list_item_options_float_red {
                font-size: 14px;
                font-weight: 400;
                color: #FF3F3F;
              }
            }

            .lifeAlbum_pic_list_item_options_float_all:hover {
              background-color: #F3F3F3;
              border-radius: 5px;
            }

            .lifeAlbum_pic_list_item_options_float_line {
              margin-left: 8px;
              width: 64px;
              height: 1px;
              background: #D5D5D5;
            }
          }
        }

        .lifeAlbum_pic_edit_list_item {
          margin: 0 30px 10px 0;
          text-align: center;

          .lifeAlbum_pic_edit_list_item_content {
            width: 240px;
            height: 135px;
            position: relative;
            border-radius: 5px;
            overflow: hidden;

            img {
              width: 240px;
              height: 135px;
              overflow: hidden;
              object-fit: cover;
            }

            .lifeAlbum_pic_edit_list_item_bg {
              position: absolute;
              left: 0;
              top: 0;
              z-index: 1;
            }

            .lifeAlbum_pic_edit_list_item_process {
              position: absolute;
              left: 0;
              right: 0;
              top: 0;
              bottom: 0;
              width: 240px;
              height: 135px;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              background: rgba(0, 0, 0, 0.4);

              .lifeAlbum_pic_edit_list_item_process_success {
                z-index: 1;
                width: 30px;
                height: 30px;
              }

              .lifeAlbum_pic_edit_list_item_process_failed {
                z-index: 1;
                width: 56px;
                height: 63px;
                cursor: pointer;
              }

              .lifeAlbum_pic_edit_list_item_process_bar {
                z-index: 1;
                position: absolute;
                left: 10px;
                bottom: 10px;
                width: 220px;
              }
            }
          }
        }
      }

      .lifeAlbum_pic_composite_list {
        display: flex;
        flex-wrap: wrap;
        margin: 30px 142px 0 142px;

        .lifeAlbum_pic_composite_list_item {
          margin: 0 40px 30px 0;
        }

        .lifeAlbum_pic_composite_list_item_content {
          cursor: pointer;
          background-color: rgba(241, 244, 249, 1);

          img {
            object-fit: contain !important;
          }
        }
      }

      .lifeAlbum_pic_composite_list.justify_content_center {
        justify-content: center;
      }

      .lifeAlbum_pic_composite_list_item_content.cursor_auto {
        cursor: auto;
      }

      .lifeAlbum_pic_composite_loading {
        color: #2c90ff;
        margin: 30px 0 30px -20px;
        text-align: center;

        img {
          width: 20px;
          height: 20px;
        }
      }

      .lifeAlbum_pic_composite_template {
        width: 1100px;
        height: 700px;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }

    .lifeAlbum_pic_button {
      text-align: center;
      margin: 0 110px 0 20px;
      height: 100px;
      line-height: 80px;
    }

    .lifeAlbum_template_content {
      min-height: 400px;
      max-height: 620px;
      margin: 0 80px 0 20px;

      .lifeAlbum_template_flex {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        height: 400px;

        .lifeAlbum_template_form {
          width: 500px;

          .el-form-item {
            margin-top: 10px;
          }

          span {
            margin-left: 20px;
            color: #2c90ff;
            cursor: pointer;
          }

          .template_subtitle_disabled {
            color: #C0C4CC;
            cursor: not-allowed;
          }
        }
      }
    }

    .lifeAlbum_video_flex {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 10px 0 30px 0;

      .lifeAlbum_video_process {
        height: 540px;

        .lifeAlbum_video_process_bar {
          width: 500px;
          margin-top: 280px;
        }

        .lifeAlbum_video_process_span {
          display: block;
          margin-top: 10px;
          text-align: center;
        }

        a {
          width: 100%;
          display: block;
          text-align: center;
          padding-top: 10px;
          color: #2c90ff;
        }
      }

      .lifeAlbum_video_info {
        width: 960px;
        height: 540px;
        overflow: hidden;
        object-fit: cover;
        background-color: red;
      }
    }

    .lifeAlbum_video_button {
      text-align: center;
      height: 100px;
      line-height: 80px;

      button {
        height: 54px;
        width: 150px;
        margin: 0 40px 0 0;
        padding: 0;
      }

      button:last-child {
        margin: 0;
        background-color: #00bb9a !important;
        border-color: #00bb9a !important;
      }

      .lifeAlbum_video_download_button {
        position: relative;

        p:first-child {
          position: absolute;
          top: 10px;
          left: 0;
          width: 100%;
        }

        p:last-child {
          position: absolute;
          top: 30px;
          left: 0;
          width: 100%;
        }
      }
    }
  }

  .lifeAlbum_pic_ai_replace_modal {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 1;
    background: #000;
    z-index: 2000;
  }

  .lifeAlbum_pic_ai_replace {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: hidden;
    margin: 0;
    z-index: 2001;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;

    .lifeAlbum_pic_ai_replace_content {
      display: flex;
      justify-content: space-evenly;
      margin-top: 60px;

      .lifeAlbum_pic_ai_replace_content_item {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor: pointer;

        .lifeAlbum_pic_ai_replace_close {
          position: absolute;
          top: -60px;
          right: 0;
          width: 38px;
          height: 36px;
        }

        img {
          max-width: 600px;
          max-height: 600px;
        }

        label {
          margin-top: 30px;
          color: #fff;
        }

        .lifeAlbum_pic_ai_download {
          position: absolute;
          right: 0;
          bottom: 46px;
          background-color: #2c90ff;
          width: 50px;
          text-align: center;
          color: #fff;
          font-size: 14px;
        }
      }
    }

    .lifeAlbum_pic_ai_replace_button {
      text-align: center;

      button {
        width: 200px;
      }
    }
  }

  .lifeAlbum_pic_ai_edit_modal {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 1;
    background: #000;
    z-index: 2000;
  }

  .lifeAlbum_pic_ai_edit_loading {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 2002;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #000;

    img {
      width: 54px;
      height: 54px;
    }
  }

  .lifeAlbum_pic_ai_edit_content_item_loading {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 2002;
  }

  .lifeAlbum_pic_ai_edit {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: hidden;
    margin: 0;
    z-index: 2001;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    display: none;

    .lifeAlbum_pic_ai_edit_content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 1400px;
      height: 820px;
      background-color: #333;
      border-radius: 5px 5px 0 0;
      position: relative;

      .lifeAlbum_pic_ai_edit_content_bar {
        span {
          position: absolute;
          top: 12px;
          cursor: pointer;
          font-size: 18px;
          color: #FFFFFF;
        }

        span:first-child {
          left: 20px;
        }

        span:last-child {
          right: 20px;
        }
      }

      .lifeAlbum_pic_ai_edit_content_navigation {
        img {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          cursor: pointer;
          width: 30px;
          height: 56px;
        }

        img:first-child {
          left: -100px;
        }

        img:last-child {
          right: -100px;
        }
      }

      .lifeAlbum_pic_ai_edit_content_item {
        position: relative;
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        align-items: flex-start;
        width: 100%;

        // height: 700px;
        .lifeAlbum_pic_ai_edit_close {
          position: absolute;
          top: -48px;
          right: 2px;
          width: 38px;
          height: 36px;
          cursor: pointer;
        }

        .lifeAlbum_pic_ai_edit_content_item_loading_pic {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          z-index: 1;
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            width: 54px;
            height: 54px;
          }
        }

        .lifeAlbum_pic_ai_edit_slider {
          position: absolute;
          top: 0;
          display: flex;
          align-items: center;
          flex-direction: column;
          justify-content: center;
          height: 100%;

          .lifeAlbum_pic_ai_edit_slider_line {
            width: 2px;
            background: #fff;
            flex: 0 1 auto;
            height: 100%;
            box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
          }

          .lifeAlbum_pic_ai_edit_slider_handle {
            position: relative;
            border: 2px solid white;
            height: 40px;
            width: 40px;
            border-radius: 100%;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: center;
            flex: 1 0 auto;

            .lifeAlbum_pic_ai_edit_slider_handle_span_before {
              position: absolute;
              left: -62px;
              width: 56px;
              text-align: center;
              color: #000;
              font-size: 14px;
              background-color: #d7d7d7;
              border-radius: 6px;
            }

            .lifeAlbum_pic_ai_edit_slider_handle_span_after {
              position: absolute;
              left: 42px;
              width: 56px;
              text-align: center;
              color: #FFF;
              font-size: 14px;
              background-color: #1abc9c;
              border-radius: 6px;
            }
          }

          .lifeAlbum_pic_ai_edit_slider_left_arrow {
            border-width: 6px;
            border-style: inset solid inset inset;
            border-color: rgba(0, 0, 0, 0) white rgba(0, 0, 0, 0) rgba(0, 0, 0, 0);
            border-image: initial;
            margin-left: -10px;
            margin-right: 10px;
            height: 0;
            width: 0;
          }

          .lifeAlbum_pic_ai_edit_slider_right_arrow {
            border-width: 6px;
            border-style: inset inset inset solid;
            border-color: rgba(0, 0, 0, 0) rgba(0, 0, 0, 0) rgba(0, 0, 0, 0) white;
            border-image: initial;
            margin-right: -10px;
            height: 0;
            width: 0;
          }
        }

        .lifeAlbum_pic_ai_edit_img {
          position: absolute;
          top: 0;
          background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC');
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            height: 100%;
            width: 100%;
            min-width: 30rem;
            min-height: 50rem;
            max-width: 1100px;
            max-height: 700px;
            object-fit: contain;
          }

          .lifeAlbum_pic_ai_edit_img_comfirm {
            width: auto;
            height: auto;
            min-width: auto;
            min-height: auto;
          }
        }

        .lifeAlbum_pic_ai_edit_button {
          p {
            width: 80px;
            height: 38px;
            line-height: 38px;
            font-size: 13px;
            border: 1px solid #1ABC9C;
            border-radius: 5px;
            color: #1ABC9C;
            text-align: center;
            margin-bottom: 22px;
            cursor: pointer;
          }

          .lifeAlbum_pic_ai_edit_button_reset {
            position: absolute;
            bottom: -12px;
            margin-bottom: 0;
            border: 0;
            color: #2C90FF;
          }

          .lifeAlbum_pic_ai_edit_button_reset.disable {
            cursor: default;
            color: #AAAAAA;
          }

          .lifeAlbum_pic_ai_edit_button_download {
            position: absolute;
            bottom: 12px;
            background-color: #1abc9c;
            border-color: #1abc9c;
            color: #FFF;
          }
        }

        .lifeAlbum_pic_ai_edit_angle_img {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 100%;
          background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC');

          img {
            width: 100%;
            height: 100%;
            max-width: 500px;
            max-height: 500px;
            object-fit: contain;
          }
        }

        .lifeAlbum_pic_ai_edit_angle {
          position: absolute;
          left: 0;
          bottom: -32px;
          // width: 447px;
          height: 30px;
          overflow: hidden;

          .lifeAlbum_pic_ai_edit_angle_item {
            position: absolute;
            display: flex;
            cursor: e-resize;
            height: 30px;

            div {
              position: relative;
              width: 2px;
              height: 2px;
              border-radius: 50%;
              background: #FFF;
              margin-left: 8px;
            }

            span {
              position: absolute;
              color: #fff;
              font-size: 12px;
              line-height: 1;
              left: -19px;
              top: 5px;
              width: 40px;
              text-align: center;
            }
          }

          .lifeAlbum_pic_ai_edit_angle_pointer {
            position: absolute;
            top: 18px;
            left: 50%;
            width: 0;
            height: 0;
            border-left: 5px solid transparent;
            border-right: 5px solid transparent;
            border-bottom: 10px solid #ffffff;
          }

          .lifeAlbum_pic_ai_edit_angle_left_svg {
            position: absolute;
            left: 0;
            color: #fff;
            cursor: pointer;
          }

          .lifeAlbum_pic_ai_edit_angle_right_svg {
            position: absolute;
            right: 0;
            color: #fff;
            cursor: pointer;
          }
        }
      }
    }

    .lifeAlbum_pic_ai_edit_button_confirm {
      width: 1200px;
      background-color: #333;
      padding-bottom: 40px;
      text-align: center;
      border-radius: 0 0 5px 5px;

      button {
        width: 200px;
      }
    }
  }

  .lifeAlbum_template_view_drawer {
    .lifeAlbum_template_view_button {
      position: absolute;
      top: 14px;
      right: 20px;
    }

    .lifeAlbum_template_view_flex {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;

      .lifeAlbum_template_view_radio {
        padding-top: 10px;
      }

      .lifeAlbum_template_view_bg {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        margin: 0 0 20px 40px;
        cursor: pointer;

        img {
          width: 240px;
          height: 135px;
        }
      }

      .lifeAlbum_template_view_music {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        margin: 0 0 20px 40px;
        cursor: pointer;
      }

      .lifeAlbum_template_view_music_bg {
        width: 175px;
        height: 180px;
      }

      .lifeAlbum_template_view_music_button {
        position: absolute;
        left: 68px;
        top: 71px;
        width: 38px;
        height: 38px;
      }

      .lifeAlbum_template_view_music_text {
        position: absolute;
        top: 119px;
        left: 58px;
        line-height: 20px;
        height: 20px;
        font-size: 14px;
        font-weight: 500;
        color: #FFFFFF;
      }

      .lifeAlbum_template_view_subtitle {
        display: flex;
        flex-direction: column;
        position: relative;
        margin: 0 0 20px 20px;
        width: 422px;
        background-color: rgba(237, 237, 237, 0.5);
        cursor: pointer;

        label {
          padding: 6px 0 0px 0.8rem;
        }

        pre {
          font-size: 16px;
          font-family: 'Microsoft Yahei', '微软雅黑', Arial, sans-serif;
          padding: 0 8px 8px 8px;
          white-space: pre-wrap; /* 保留空白符，自动换行 */
          word-wrap: break-word; /* 长单词或URL内部进行换行 */
        }
      }
    }
  }
}
</style>

<style lang="stylus">
.lifeAlbum_step_body .el-steps {
  padding: 30px;
  justify-content: center;
}

.lifeAlbum_step_body .el-step__line {
  top: 31px !important;
  height: 4px !important;
}

.lifeAlbum_step_body .el-step__line-inner {
  border-width: 2px !important;
}

.lifeAlbum_pic_ai_edit_content_item .cropper-view-box {
  outline: 2px solid #39f !important;
}

.lifeAlbum_step_body .el-step__icon {
  width: 64px !important;
  height: 64px !important;
  font-size: 34px !important;
  border: 4px solid !important;
}

.lifeAlbum_pic_bar_buttons .el-button {
  margin-left: 10px !important;
  min-width: 100px !important;
}

.lifeAlbum_video_process .el-progress-bar__innerText {
  color: #000;
}

.dialog_cut_image {
  .el-dialog__header {
    padding: 10px 0;
    border-bottom: 1px solid #e6e6e6;
    text-indent: 30px;
    height: 50px;
    line-height: 50px;
  }

  .el-dialog__title {
    font-size: 34px;
    font-weight: 500;
    color: #000;
    line-height: 60px;
  }

  .cropper-content {
    .cropper {
      width: auto;
      height: 300px;
    }
  }

  .size_btns {
    .el-button {
      margin-left: 0;
    }
  }
}

.lifeAlbum_template_view_drawer {
  .el-drawer__body {
    overflow-y: auto;
  }
}

.lifeAlbum_template_view_subtitle .el-radio__label {
  font-size: 18px;
}

.dialog_cut_image .cropper-view-box {
  outline: 5px solid #39f;
}
</style>


// WEBPACK FOOTER //
// src/pages/PartII/SpaceDetails/components/SpaceLifeAlbum.vue